export const data = [
    {
      "photos": [
        "https://photos.zillowstatic.com/fp/73fc597796e14eb458c24f9a9820b388-p_d.jpg",
        "https://photos.zillowstatic.com/fp/bb30eb81989d1a47e8db982c7a1da152-p_d.jpg",
        "https://photos.zillowstatic.com/fp/4e797aa692c062caa57015e369e8f9df-p_d.jpg",
        "https://photos.zillowstatic.com/fp/b5a36a57fe8c408a28af351a6c48cd50-p_d.jpg",
        "https://photos.zillowstatic.com/fp/346ed20c68c668904902b4778c7693e1-p_d.jpg",
        "https://photos.zillowstatic.com/fp/b7b2f70f987d806cf5a7847a0973c8c8-p_d.jpg",
        "https://photos.zillowstatic.com/fp/8c33c87924ba738d89977ed889fcc946-p_d.jpg",
        "https://photos.zillowstatic.com/fp/f0620e61d611533e83129df5fcf2fd88-p_d.jpg",
        "https://photos.zillowstatic.com/fp/0917d74fe65f4240777dd93d7ce1a35e-p_d.jpg",
        "https://photos.zillowstatic.com/fp/033222358fcfdd3d9c39f280ca3a312e-p_d.jpg",
        "https://photos.zillowstatic.com/fp/cd099fb2aed2be7dedae743698e43fe3-p_d.jpg",
        "https://photos.zillowstatic.com/fp/069f3ac781f4f1a197bd2e2d8ac5623e-p_d.jpg",
        "https://photos.zillowstatic.com/fp/1635901b3f46b180c8578e1c36762c4f-p_d.jpg",
        "https://photos.zillowstatic.com/fp/f33bc70341b696e281e581d817bd67d5-p_d.jpg",
        "https://photos.zillowstatic.com/fp/60becf0dcbcb55a381b11b98b47edfdc-p_d.jpg",
        "https://photos.zillowstatic.com/fp/9396266cfe8a0aa2057e79e701aa6ad8-p_d.jpg",
        "https://photos.zillowstatic.com/fp/ad7336da8f61a230df6a9bf51c446071-p_d.jpg",
        "https://photos.zillowstatic.com/fp/b24d03d5c245a8f0d8c24bd8544cafa6-p_d.jpg",
        "https://photos.zillowstatic.com/fp/362bedacc10c5b45d823e5b5f63036f8-p_d.jpg",
        "https://photos.zillowstatic.com/fp/1800906dcc6f61f29305a5dc29f42bb9-p_d.jpg",
        "https://photos.zillowstatic.com/fp/c38decc78edf79f048404e6c39f122c0-p_d.jpg",
        "https://photos.zillowstatic.com/fp/eb8d7231438eabd289fb3a1188eeba40-p_d.jpg",
        "https://photos.zillowstatic.com/fp/3d6aaaa93800a7fcde31cecf058efe46-p_d.jpg",
        "https://photos.zillowstatic.com/fp/fa771ab7a19f993dfd2024f61e0e1d6c-p_d.jpg",
        "https://photos.zillowstatic.com/fp/59b1f60d8cb11ec39dc6e686a46b8609-p_d.jpg",
        "https://photos.zillowstatic.com/fp/cd43fa814f9fdf9110baf98c3e2f2d41-p_d.jpg",
        "https://photos.zillowstatic.com/fp/683d45a4d30636b9b5c3f7da221925da-p_d.jpg",
        "https://photos.zillowstatic.com/fp/e5be3b961a00a5feaaf6bdf675364e06-p_d.jpg",
        "https://photos.zillowstatic.com/fp/c4ad75e1c98efbdab635182b5828f2e7-p_d.jpg",
        "https://photos.zillowstatic.com/fp/c5e1a2dfb45f2094f2e341f69a916953-p_d.jpg",
        "https://photos.zillowstatic.com/fp/26aecb7810c07812b54c0d64758dba02-p_d.jpg",
        "https://photos.zillowstatic.com/fp/dcbb08c96345420fa1da4f3f220b776f-p_d.jpg",
        "https://photos.zillowstatic.com/fp/e669d9df08b72bade589212d19c12433-p_d.jpg",
        "https://photos.zillowstatic.com/fp/052ae730c2c218453774e9bf3a4b9165-p_d.jpg",
        "https://photos.zillowstatic.com/fp/c8f3190dcf74c7e2d0a8af23a76ad67c-p_d.jpg",
        "https://photos.zillowstatic.com/fp/6fb283512034d1a9b1c8091bd268f0da-p_d.jpg",
        "https://photos.zillowstatic.com/fp/d0d490a3b9534a585b6de7153e4bdb6b-p_d.jpg",
        "https://photos.zillowstatic.com/fp/4dc90c83093908dd36453dcbcde3cd17-p_d.jpg",
        "https://photos.zillowstatic.com/fp/65ec7111dc3193c9e529bbc71471211b-p_d.jpg",
        "https://photos.zillowstatic.com/fp/547335e97d26a62d0ebf156b6b3b59c5-p_d.jpg",
        "https://photos.zillowstatic.com/fp/5a7afe9173ca8a025af59665bfeeccf6-p_d.jpg",
        "https://photos.zillowstatic.com/fp/6c4038b9f93e9c407e93b9d03fc21ed5-p_d.jpg"
      ],
      "homeStatus": "FOR_SALE",
      "price": 568,
      "rating": 7,
      "type": "Guest House",
      "address": {
        "streetAddress": "3364 Bennett Dr",
        "city": "Los Angeles",
        "state": "CA",
        "zipcode": "90068",
        "neighborhood": null,
        "community": null,
        "subdivision": null
      },
      "yearBuilt": 1932,
      "bedrooms": 3,
      "bathrooms": 2,
      "livingArea": 1732,
      "url": "https://www.zillow.com/homedetails/3364-Bennett-Dr-Los-Angeles-CA-90068/20045758_zpid/",
      "_id": "htmmuqtq58e",
      "__index": 1
    },
    {
      "photos": [
        "https://photos.zillowstatic.com/fp/77637e180ed5eea2802408a926435f09-p_d.jpg",
        "https://photos.zillowstatic.com/fp/b05e301041755b2081ab7b9c6af08c78-p_d.jpg",
        "https://photos.zillowstatic.com/fp/066cf14fc27819da4877e83705de99bd-p_d.jpg",
        "https://photos.zillowstatic.com/fp/a1b985e380487325bd5633138257ba02-p_d.jpg",
        "https://photos.zillowstatic.com/fp/0db70855dc7ff324f8a817a95953a0f3-p_d.jpg",
        "https://photos.zillowstatic.com/fp/68fa14eed41d5c5df2906768f81a2a34-p_d.jpg",
        "https://photos.zillowstatic.com/fp/bf5df2ee22959036f521368877e6502b-p_d.jpg",
        "https://photos.zillowstatic.com/fp/7f919efba68a06c4a486ea10f656bb94-p_d.jpg",
        "https://photos.zillowstatic.com/fp/3f054844ba2d7c79d3448e92eabc7d59-p_d.jpg",
        "https://photos.zillowstatic.com/fp/cc4ecf2477b3ac3e312da9d0e60eef9b-p_d.jpg",
        "https://photos.zillowstatic.com/fp/95a1c5ff68f7e5b38aafd70a1a18c7b8-p_d.jpg",
        "https://photos.zillowstatic.com/fp/0ae1b355e44030ff5be7def00a4282c5-p_d.jpg",
        "https://photos.zillowstatic.com/fp/2cd72c75cc84cdaafe68ac9a4322c178-p_d.jpg"
      ],
      "homeStatus": "FOR_SALE",
      "price": 5306,
      "rating": 2,
      "type": "Apartment",
      "address": {
        "streetAddress": "8193 Gould Ave",
        "city": "Los Angeles",
        "state": "CA",
        "zipcode": "90046",
        "neighborhood": null,
        "community": null,
        "subdivision": null
      },
      "yearBuilt": 1927,
      "bedrooms": 2,
      "bathrooms": 2,
      "livingArea": 1257,
      "url": "https://www.zillow.com/homedetails/8193-Gould-Ave-Los-Angeles-CA-90046/20797560_zpid/",
      "_id": "6n9pa1q5n16",
      "__index": 2
    },
    {
      "photos": [
        "https://photos.zillowstatic.com/fp/2acc0c5dc14e451d852f64ade49e8f53-p_d.jpg",
        "https://photos.zillowstatic.com/fp/177096defc515d3be607a1847b70e5f2-p_d.jpg",
        "https://photos.zillowstatic.com/fp/91fddffe68a5be71c86129ba515bf66a-p_d.jpg",
        "https://photos.zillowstatic.com/fp/7655af7eaba1330420c7638b47315e1b-p_d.jpg",
        "https://photos.zillowstatic.com/fp/266d33cd254d034be474c888ca36a12e-p_d.jpg",
        "https://photos.zillowstatic.com/fp/56841fddacfb4ebd123384b09abc5062-p_d.jpg"
      ],
      "homeStatus": "FOR_SALE",
      "price": 2042,
      "rating": 4,
      "type": "Villa",
      "address": {
        "streetAddress": "14703 S Denver Ave",
        "city": "Gardena",
        "state": "CA",
        "zipcode": "90248",
        "neighborhood": null,
        "community": null,
        "subdivision": null
      },
      "yearBuilt": 1949,
      "bedrooms": 3,
      "bathrooms": 2,
      "livingArea": 1190,
      "url": "https://www.zillow.com/homedetails/14703-S-Denver-Ave-Gardena-CA-90248/20986678_zpid/",
      "_id": "qu6lvunzxtp",
      "__index": 3
    },
    {
      "photos": [
        "https://photos.zillowstatic.com/fp/cec6d147f119d9c538f5c1838aadfdc3-p_d.jpg",
        "https://photos.zillowstatic.com/fp/8bc9792f0c1c3e16f8b7e423d0fb1f86-p_d.jpg",
        "https://photos.zillowstatic.com/fp/afaa36f3fc4f02e7dfaa46fd7f655c7d-p_d.jpg",
        "https://photos.zillowstatic.com/fp/1928f7535e3b043c783b22222f15d6f5-p_d.jpg",
        "https://photos.zillowstatic.com/fp/af55ece8f21da86a967267080bf7305a-p_d.jpg",
        "https://photos.zillowstatic.com/fp/294faa26d99a53e7c986860ea65834f8-p_d.jpg",
        "https://photos.zillowstatic.com/fp/b9d8cb2cbdd0596fe870805796d427ad-p_d.jpg",
        "https://photos.zillowstatic.com/fp/a4b21f056a099bc3809cb9a1cf5c7d12-p_d.jpg",
        "https://photos.zillowstatic.com/fp/d2af23aa896ea67766b1b10680e6cbc5-p_d.jpg",
        "https://photos.zillowstatic.com/fp/f5fe7d87caa20945b99ef6587c571113-p_d.jpg",
        "https://photos.zillowstatic.com/fp/1d71ca393e1996d9cffbf019e1057a43-p_d.jpg",
        "https://photos.zillowstatic.com/fp/1458d74a3d864cf5290becf3ee4cff22-p_d.jpg",
        "https://photos.zillowstatic.com/fp/2a5c4459496b634bfed16bac0124cc7d-p_d.jpg",
        "https://photos.zillowstatic.com/fp/64808b303048e3cceb25feaa1d2571ab-p_d.jpg",
        "https://photos.zillowstatic.com/fp/8beb7edf16bd0cf3ac4ae643345b2f41-p_d.jpg",
        "https://photos.zillowstatic.com/fp/38b56e11bb0e7c904dadd9035744c9af-p_d.jpg",
        "https://photos.zillowstatic.com/fp/7be88418b6b260395a83c06e118b0300-p_d.jpg",
        "https://photos.zillowstatic.com/fp/433d1714e39338f853da7acc72962861-p_d.jpg",
        "https://photos.zillowstatic.com/fp/723aa605ac0f58b78632abf7f824c7ac-p_d.jpg",
        "https://photos.zillowstatic.com/fp/22686490bfe2761ce0eb6e2169c77d0a-p_d.jpg",
        "https://photos.zillowstatic.com/fp/176fcb9527943d5e8cb7a709f5daac37-p_d.jpg",
        "https://photos.zillowstatic.com/fp/696f4b54aa4dd26f3f4ac726d9c05ca9-p_d.jpg",
        "https://photos.zillowstatic.com/fp/38930f1841576fc86023ceb3b8d41b97-p_d.jpg",
        "https://photos.zillowstatic.com/fp/23ac5ae00bea08b741fb397fb63f387f-p_d.jpg",
        "https://photos.zillowstatic.com/fp/fa5e7140a61b29384f456af2a99f201c-p_d.jpg",
        "https://photos.zillowstatic.com/fp/2cb235ae994f543a80e33875b2e4c6e4-p_d.jpg",
        "https://photos.zillowstatic.com/fp/02d35c3bf7cc1db0acae03842f94fd22-p_d.jpg",
        "https://photos.zillowstatic.com/fp/6f6e40bb6728229eca7405954bc53df7-p_d.jpg",
        "https://photos.zillowstatic.com/fp/4590050869a5acd445176715ef19a431-p_d.jpg",
        "https://photos.zillowstatic.com/fp/b33cd4b5fad37409d6881cec36d10001-p_d.jpg",
        "https://photos.zillowstatic.com/fp/a06b52e23b07aa7d3d3d2eea1f9fd7c7-p_d.jpg",
        "https://photos.zillowstatic.com/fp/6a820441b1193cbd34956a3208b639ba-p_d.jpg",
        "https://photos.zillowstatic.com/fp/7919eb09fed7a2902aaa06b4463b2f9f-p_d.jpg",
        "https://photos.zillowstatic.com/fp/b6e40e5d40265967f8b11c7a48aece28-p_d.jpg",
        "https://photos.zillowstatic.com/fp/cb3b73462f6aea55d006160155208027-p_d.jpg",
        "https://photos.zillowstatic.com/fp/f97bdf507d11c032bab6292e64e4dcb1-p_d.jpg",
        "https://photos.zillowstatic.com/fp/0dcf16faa96e4d4573f24a14897512b4-p_d.jpg",
        "https://photos.zillowstatic.com/fp/4dd9d805edcf3e7f59ae90d7ea9448bf-p_d.jpg",
        "https://photos.zillowstatic.com/fp/ab8661e2bf3141c53cb653ce9c716623-p_d.jpg",
        "https://photos.zillowstatic.com/fp/534e657f58cb73b7e059297c0902423c-p_d.jpg",
        "https://photos.zillowstatic.com/fp/3605099bf898053fff7efb0854442644-p_d.jpg",
        "https://photos.zillowstatic.com/fp/1fc9b00ac8059ee05a6e525b2ab51594-p_d.jpg",
        "https://photos.zillowstatic.com/fp/be4e5d86b25cc3501839bbbdaeab8688-p_d.jpg",
        "https://photos.zillowstatic.com/fp/1881cbec70297e021cc2fc2edc40825d-p_d.jpg",
        "https://photos.zillowstatic.com/fp/1d57e3817937cd7143e6c098a701a9cc-p_d.jpg",
        "https://photos.zillowstatic.com/fp/f9449273ac2aeece4bb64a04bca5f04b-p_d.jpg",
        "https://photos.zillowstatic.com/fp/a27791898f5ce92da9c9f4d2f8783f54-p_d.jpg",
        "https://photos.zillowstatic.com/fp/6d74203a1b24f08a4e5219130d64324e-p_d.jpg",
        "https://photos.zillowstatic.com/fp/04b4d342eac79e155118187ed8c5eb5a-p_d.jpg",
        "https://photos.zillowstatic.com/fp/8f50d8e37a257c264cb7c3d0edaf9d15-p_d.jpg"
      ],
      "homeStatus": "FOR_SALE",
      "price": 962,
      "rating": 4.5,
      "type": "Villa",
      "address": {
        "streetAddress": "20552 Kingsbury St",
        "city": "Chatsworth",
        "state": "CA",
        "zipcode": "91311",
        "neighborhood": null,
        "community": null,
        "subdivision": null
      },
      "yearBuilt": 1981,
      "bedrooms": 5,
      "bathrooms": 3,
      "livingArea": 3332,
      "url": "https://www.zillow.com/homedetails/20552-Kingsbury-St-Chatsworth-CA-91311/20158113_zpid/",
      "_id": "fcabag17zjh",
      "__index": 4
    },
    {
      "photos": [
        "https://photos.zillowstatic.com/fp/acebb335725bec9acfd8a243e53188cd-p_d.jpg",
        "https://photos.zillowstatic.com/fp/876ebe333ded90ffa4dc1d9344817ebc-p_d.jpg",
        "https://photos.zillowstatic.com/fp/91e2178dea540dfe7d6fb14bb983eeb7-p_d.jpg",
        "https://photos.zillowstatic.com/fp/230691cdc426e81f6aa3e9db3d509810-p_d.jpg",
        "https://photos.zillowstatic.com/fp/ffc137b429039037b930c37933caac9d-p_d.jpg",
        "https://photos.zillowstatic.com/fp/08ebf890fe9c47e4946c3d589c9ec960-p_d.jpg",
        "https://photos.zillowstatic.com/fp/f00ded3b9e49a8ac9e11219dc93978ac-p_d.jpg",
        "https://photos.zillowstatic.com/fp/1ed6d3d7825de7498e925ba340439017-p_d.jpg",
        "https://photos.zillowstatic.com/fp/6ac240b98541901564c2fb1e070bfdef-p_d.jpg",
        "https://photos.zillowstatic.com/fp/e645c7e9875fbbae7326f85b5214f144-p_d.jpg",
        "https://photos.zillowstatic.com/fp/a6c80708a443992b88cfaffe5166ace5-p_d.jpg",
        "https://photos.zillowstatic.com/fp/c8a06369d8fe2e54ee6a2abe722ae986-p_d.jpg",
        "https://photos.zillowstatic.com/fp/fc4ef1bb69f3fc81c872960a6e15a383-p_d.jpg",
        "https://photos.zillowstatic.com/fp/c87056dad4fe97309a8d5f143df4c90d-p_d.jpg",
        "https://photos.zillowstatic.com/fp/511513fa58bede074620a4308a437c77-p_d.jpg",
        "https://photos.zillowstatic.com/fp/66ddb685cc9ab21a76dd457225dd46e1-p_d.jpg",
        "https://photos.zillowstatic.com/fp/87cebcaf446675dd1174834396339295-p_d.jpg",
        "https://photos.zillowstatic.com/fp/ff5d76092460a2319a5ab63bca7a2420-p_d.jpg",
        "https://photos.zillowstatic.com/fp/28de1d842d26b0f7ef9de5967c1dde89-p_d.jpg",
        "https://photos.zillowstatic.com/fp/650a6e4b12d114c5dd998c995d18dbdd-p_d.jpg",
        "https://photos.zillowstatic.com/fp/761077d34b41369c54a3351401928b0b-p_d.jpg",
        "https://photos.zillowstatic.com/fp/db06038335f296da14360fb9d78adb81-p_d.jpg",
        "https://photos.zillowstatic.com/fp/213cc7b4dc0b71461c7392720d879870-p_d.jpg",
        "https://photos.zillowstatic.com/fp/8c7e437dd10dcf2f12eee72c2afa062e-p_d.jpg",
        "https://photos.zillowstatic.com/fp/c080f62bcabc53f2424edc21d2c67599-p_d.jpg",
        "https://photos.zillowstatic.com/fp/e8e9b4ed22685a96714437e7f77e297e-p_d.jpg",
        "https://photos.zillowstatic.com/fp/d635c2f1586a3341846972161b992d19-p_d.jpg",
        "https://photos.zillowstatic.com/fp/3aef4ed64f7a495c2d4ad26c2f699675-p_d.jpg",
        "https://photos.zillowstatic.com/fp/a8793220543d9051abffdf787b2f6204-p_d.jpg",
        "https://photos.zillowstatic.com/fp/db305861f8cdc0b66fcd5b5ec6b37040-p_d.jpg",
        "https://photos.zillowstatic.com/fp/780f7eabd59632b0c6c53b6d896e8683-p_d.jpg",
        "https://photos.zillowstatic.com/fp/cdb8bef52ac9f63ba45b1ccda7b4ad80-p_d.jpg",
        "https://photos.zillowstatic.com/fp/035d86858eaec6fa8ac56e60dbe53879-p_d.jpg",
        "https://photos.zillowstatic.com/fp/293dc64a62136a19ec4582975bacd3ad-p_d.jpg",
        "https://photos.zillowstatic.com/fp/895be00308b532a8af42cf02163161d4-p_d.jpg",
        "https://photos.zillowstatic.com/fp/64a722d0edcf6f5413ec53e5bc2c03e2-p_d.jpg",
        "https://photos.zillowstatic.com/fp/a7ada71f568bf0119a9d5dc658b8dbc8-p_d.jpg",
        "https://photos.zillowstatic.com/fp/82df05376453c6b9eaace3f89f76b212-p_d.jpg",
        "https://photos.zillowstatic.com/fp/b0906c71f1bb049f6465d272b7b7b395-p_d.jpg",
        "https://photos.zillowstatic.com/fp/849e1700e0cba953f730e929916cbd85-p_d.jpg",
        "https://photos.zillowstatic.com/fp/831b53619fcb029d0e96fc603c1cf438-p_d.jpg",
        "https://photos.zillowstatic.com/fp/96c33f73aeb1eb836afe9c61d71aed58-p_d.jpg",
        "https://photos.zillowstatic.com/fp/b2b1a7bc09e837d585f555b51ca74021-p_d.jpg",
        "https://photos.zillowstatic.com/fp/6ad8f4f00dbe3d644d4be80b29c83c69-p_d.jpg",
        "https://photos.zillowstatic.com/fp/9048a0e269106e4fd723364e7caae8d9-p_d.jpg",
        "https://photos.zillowstatic.com/fp/97e5786f044df1718235a951d166e146-p_d.jpg",
        "https://photos.zillowstatic.com/fp/875795293c4191c3ab9e28fe2aa65626-p_d.jpg",
        "https://photos.zillowstatic.com/fp/c71431ee3c47ef0107de8e6346e8c01a-p_d.jpg",
        "https://photos.zillowstatic.com/fp/74eaeeca0ff0083b8c05dd11182522d5-p_d.jpg",
        "https://photos.zillowstatic.com/fp/0d63c726f04981272a868b66803b80d1-p_d.jpg",
        "https://photos.zillowstatic.com/fp/e3d0a9a12c675f963c35091116e0cafa-p_d.jpg",
        "https://photos.zillowstatic.com/fp/792260864addd23f7bb496f03fae36a2-p_d.jpg",
        "https://photos.zillowstatic.com/fp/2140ec54ecade8504f816d81fa1b33ea-p_d.jpg",
        "https://photos.zillowstatic.com/fp/013fd3092757f2fa6f24493bc5a0148b-p_d.jpg",
        "https://photos.zillowstatic.com/fp/2ada723412b9752eed49133154232a4e-p_d.jpg",
        "https://photos.zillowstatic.com/fp/288b44f83ca1ac1011d540cfe41c0091-p_d.jpg",
        "https://photos.zillowstatic.com/fp/5ada18b89f2437885663369094a2b208-p_d.jpg",
        "https://photos.zillowstatic.com/fp/1d6cfbb35f449c05c1f82f3d22587600-p_d.jpg",
        "https://photos.zillowstatic.com/fp/276d886104e276128b26b3b582b62bad-p_d.jpg",
        "https://photos.zillowstatic.com/fp/983694d8bfed24c0f8804b68d67a3492-p_d.jpg",
        "https://photos.zillowstatic.com/fp/f192919de0166a331bd90a26b6897d8f-p_d.jpg",
        "https://photos.zillowstatic.com/fp/b249a9c408104e8fcc9afa5a191f0ca6-p_d.jpg",
        "https://photos.zillowstatic.com/fp/694d60922bab5bfe1bf532467dcacff3-p_d.jpg",
        "https://photos.zillowstatic.com/fp/e4056f7a24f8450727fb715d2931020a-p_d.jpg",
        "https://photos.zillowstatic.com/fp/ab4c72a220c0bff800b4bc2912d365e3-p_d.jpg",
        "https://photos.zillowstatic.com/fp/72c516139e8f680a94888f49dde57b8c-p_d.jpg"
      ],
      "homeStatus": "FOR_SALE",
      "price": 7381,
      "rating": 6.5,
      "type": "Condo",
      "address": {
        "streetAddress": "9721 Wornom Ave",
        "city": "Sunland",
        "state": "CA",
        "zipcode": "91040",
        "neighborhood": null,
        "community": null,
        "subdivision": null
      },
      "yearBuilt": 2001,
      "bedrooms": 6,
      "bathrooms": 4,
      "livingArea": 3292,
      "url": "https://www.zillow.com/homedetails/9721-Wornom-Ave-Sunland-CA-91040/20089485_zpid/",
      "_id": "0s1jcw9hy8w",
      "__index": 5
    },
    {
      "photos": [
        "https://photos.zillowstatic.com/fp/977c453400fc2e4b03080e49c69b5ee0-p_d.jpg",
        "https://photos.zillowstatic.com/fp/cce185af6555cd77301c51eb1e97c553-p_d.jpg",
        "https://photos.zillowstatic.com/fp/e80f4c1e04644d461e8953cfd05709a2-p_d.jpg",
        "https://photos.zillowstatic.com/fp/b7c54fe2c0ffb5eaf067a447190cd145-p_d.jpg",
        "https://photos.zillowstatic.com/fp/0e618e3b891f7206676422e5bafa5903-p_d.jpg",
        "https://photos.zillowstatic.com/fp/8d985f878190285ba53268c4172368e4-p_d.jpg",
        "https://photos.zillowstatic.com/fp/5b0beb277ce10250134f9cf5731dbe6a-p_d.jpg",
        "https://photos.zillowstatic.com/fp/93803eca7084eb85a29b9a8da7658752-p_d.jpg",
        "https://photos.zillowstatic.com/fp/2b34000c1c3cdfb7e30822b037de5f32-p_d.jpg",
        "https://photos.zillowstatic.com/fp/ddae5173e0da85080450c1bb081ba237-p_d.jpg",
        "https://photos.zillowstatic.com/fp/7c7bcfa68ffe1d92e1fc37a1fbb91093-p_d.jpg",
        "https://photos.zillowstatic.com/fp/de0daf1fac2cff5d58093f7757df9743-p_d.jpg",
        "https://photos.zillowstatic.com/fp/c99d6a6e63a17f1ba534eac96c6fe9d7-p_d.jpg",
        "https://photos.zillowstatic.com/fp/deb09f53062a7d7873a140e49b131553-p_d.jpg",
        "https://photos.zillowstatic.com/fp/8bc1817dafaf92adf1b8339c5d2f2923-p_d.jpg",
        "https://photos.zillowstatic.com/fp/b077d35e4451faef8b33cea81499fd92-p_d.jpg",
        "https://photos.zillowstatic.com/fp/cb3d3f79e5a92c17c32b4d0eb996844d-p_d.jpg",
        "https://photos.zillowstatic.com/fp/c983979478d1c53f019c511be439771c-p_d.jpg",
        "https://photos.zillowstatic.com/fp/a8fcc5687e9e3f4c88dd9d936e4fe2fe-p_d.jpg",
        "https://photos.zillowstatic.com/fp/42fefbf8374714a9d9eda24b8f785000-p_d.jpg",
        "https://photos.zillowstatic.com/fp/fdd7c07e20c1f5d84fe4cd27e4e16861-p_d.jpg",
        "https://photos.zillowstatic.com/fp/4358fe7055a8c63278ebe71974df45da-p_d.jpg",
        "https://photos.zillowstatic.com/fp/6f7fefbd78c8c9c7111a09ae5ec1938c-p_d.jpg",
        "https://photos.zillowstatic.com/fp/67a053a2c70a76353240484e47bfba08-p_d.jpg",
        "https://photos.zillowstatic.com/fp/f6dd28c427d2e056d518d55447f68f45-p_d.jpg",
        "https://photos.zillowstatic.com/fp/e7e4086689f09316f3353bbea6509fbd-p_d.jpg",
        "https://photos.zillowstatic.com/fp/a9e8fe9441c3bfa3f806b0f758460607-p_d.jpg",
        "https://photos.zillowstatic.com/fp/287776feceeb4b67f34e7d8dc9a8a4f6-p_d.jpg",
        "https://photos.zillowstatic.com/fp/9e76cc62b3f9de36f504b7a71a0c3875-p_d.jpg",
        "https://photos.zillowstatic.com/fp/cbddcc1c98e15209b48b625c2de9399e-p_d.jpg",
        "https://photos.zillowstatic.com/fp/99def1f48df3411dbaed061a799d64f3-p_d.jpg",
        "https://photos.zillowstatic.com/fp/1d57c7033cd6588d6fdc74a7610583d9-p_d.jpg",
        "https://photos.zillowstatic.com/fp/58b5cbe7a692aac04f522f85be3b0afc-p_d.jpg",
        "https://photos.zillowstatic.com/fp/fa7e861d686cb9659fa41fd82eb69954-p_d.jpg",
        "https://photos.zillowstatic.com/fp/ba01db2fa7399913afd2ba753a4e37a5-p_d.jpg",
        "https://photos.zillowstatic.com/fp/325d1e9a0ab268570957680a30489ce5-p_d.jpg",
        "https://photos.zillowstatic.com/fp/7d7ffeb67681bc9e584379b30fe335d5-p_d.jpg",
        "https://photos.zillowstatic.com/fp/b44b62f2cbb33ac9c6d169f168cd65e4-p_d.jpg",
        "https://photos.zillowstatic.com/fp/3f141f9bb242ac3977e122ddb7c09e83-p_d.jpg",
        "https://photos.zillowstatic.com/fp/d5d198d6b92b46a5fc3d4f09ff222b1b-p_d.jpg",
        "https://photos.zillowstatic.com/fp/bd5f2b4f4e6ef0c9e4aebbff0ebf523f-p_d.jpg",
        "https://photos.zillowstatic.com/fp/bf4dd507c46db90a343607b2cb3a6d48-p_d.jpg",
        "https://photos.zillowstatic.com/fp/00fd986a4c32f4dddea6acc6a9a0214d-p_d.jpg",
        "https://photos.zillowstatic.com/fp/f7e5c6e0f8550c21e3443da8b36b6d3c-p_d.jpg",
        "https://photos.zillowstatic.com/fp/e974910ef7ade37226c1705094fbd88e-p_d.jpg",
        "https://photos.zillowstatic.com/fp/2868639f2f7697dc6e00361138c3a53e-p_d.jpg",
        "https://photos.zillowstatic.com/fp/aef7c29d85e69737737ff436a1504d34-p_d.jpg",
        "https://photos.zillowstatic.com/fp/f9dc215bdfc38d750ef12edfd1ccba0b-p_d.jpg"
      ],
      "homeStatus": "FOR_SALE",
      "price": 2500,
      "rating": 8,
      "type": "Apartment",
      "address": {
        "streetAddress": "4921 York Blvd",
        "city": "Los Angeles",
        "state": "CA",
        "zipcode": "90042",
        "neighborhood": null,
        "community": null,
        "subdivision": null
      },
      "yearBuilt": 1921,
      "bedrooms": 2,
      "bathrooms": 2,
      "livingArea": 1472,
      "url": "https://www.zillow.com/homedetails/4921-York-Blvd-Los-Angeles-CA-90042/20766395_zpid/",
      "_id": "6ef7vatghkl",
      "__index": 6
    },
    {
      "photos": [
        "https://photos.zillowstatic.com/fp/44f128db631c56066aa6eb1b1aa01425-p_d.jpg",
        "https://photos.zillowstatic.com/fp/22dd245a41718a9c03757cae8636cd30-p_d.jpg",
        "https://photos.zillowstatic.com/fp/34c63b449bf5be9cdf14b9754ddaf0bc-p_d.jpg",
        "https://photos.zillowstatic.com/fp/8e1d5c760c4d603cba9b6bff4608c44d-p_d.jpg",
        "https://photos.zillowstatic.com/fp/a1e8bd64833d5b10bfc454066c537801-p_d.jpg",
        "https://photos.zillowstatic.com/fp/c70bb938000afcf07e6887aa1d8e17c4-p_d.jpg",
        "https://photos.zillowstatic.com/fp/12e35c272e0cd1ce14574bf4598ed07a-p_d.jpg"
      ],
      "homeStatus": "FOR_SALE",
      "price": 3681,
      "rating": 9,
      "type": "House",
      "address": {
        "streetAddress": "10799 Sherman Grove Ave #6",
        "city": "Sunland",
        "state": "CA",
        "zipcode": "91040",
        "neighborhood": null,
        "community": null,
        "subdivision": null
      },
      "yearBuilt": 2022,
      "bedrooms": 1,
      "bathrooms": 1,
      "livingArea": null,
      "url": "https://www.zillow.com/homedetails/10799-Sherman-Grove-Ave-6-Sunland-CA-91040/2060682377_zpid/",
      "_id": "0fvfmw9443m",
      "__index": 7
    },
    {
      "photos": [
        "https://photos.zillowstatic.com/fp/9a32fd9a4f24050e94cdd14710e1a257-p_d.jpg",
        "https://photos.zillowstatic.com/fp/bd88f05b74b721cd87c547a061fbc075-p_d.jpg",
        "https://photos.zillowstatic.com/fp/7a4a0639e92b6f95df05e0bd4bca2732-p_d.jpg",
        "https://photos.zillowstatic.com/fp/d35c30a12a7b5fc2ecb4ba2f2f210fb0-p_d.jpg",
        "https://photos.zillowstatic.com/fp/78de2bdffa55210c479a6155de95927d-p_d.jpg",
        "https://photos.zillowstatic.com/fp/c6f4055e65101d75a7001995b2a1d3fa-p_d.jpg",
        "https://photos.zillowstatic.com/fp/474e31b7574017efa96d382fb5dc0829-p_d.jpg",
        "https://photos.zillowstatic.com/fp/bc4b4b829e1c7f113f1a67b88fb9afaa-p_d.jpg",
        "https://photos.zillowstatic.com/fp/a3371e13a04c2ab249dd1cdffd25e806-p_d.jpg",
        "https://photos.zillowstatic.com/fp/c3a19339bf2f66cd71d5deb9a7f7667f-p_d.jpg",
        "https://photos.zillowstatic.com/fp/5beceff0decda3478c4ea1d25eb0d198-p_d.jpg",
        "https://photos.zillowstatic.com/fp/97689b93ea3678cdc6ffcdf85372c554-p_d.jpg",
        "https://photos.zillowstatic.com/fp/9338651af9f139b8377212ae0522043f-p_d.jpg",
        "https://photos.zillowstatic.com/fp/58ceebf58b714138a246fade99cb4605-p_d.jpg",
        "https://photos.zillowstatic.com/fp/dc1b0ca73f2af0ad919edad942235eef-p_d.jpg",
        "https://photos.zillowstatic.com/fp/4f7047391285049ca41824a5b4d63ce2-p_d.jpg",
        "https://photos.zillowstatic.com/fp/5165c89c73ca8850fd0a6038a4400cdb-p_d.jpg",
        "https://photos.zillowstatic.com/fp/c6ffbcab94ef3231e76bb4f9bc327c88-p_d.jpg",
        "https://photos.zillowstatic.com/fp/410749e1f0e03226d20ab408a177ca37-p_d.jpg"
      ],
      "homeStatus": "FOR_SALE",
      "price": 7078,
      "rating": 8,
      "type": "Guest House",
      "address": {
        "streetAddress": "6000 Coldwater Canyon Ave UNIT 10",
        "city": "North Hollywood",
        "state": "CA",
        "zipcode": "91606",
        "neighborhood": null,
        "community": null,
        "subdivision": null
      },
      "yearBuilt": 1960,
      "bedrooms": 3,
      "bathrooms": 2,
      "livingArea": 1500,
      "url": "https://www.zillow.com/homedetails/6000-Coldwater-Canyon-Ave-UNIT-10-North-Hollywood-CA-91606/2069587272_zpid/",
      "_id": "cq1dma1ogwr",
      "__index": 8
    },
    {
      "photos": [
        "https://photos.zillowstatic.com/fp/13bd9b78ab48186fec9af1f726b99b33-p_d.jpg",
        "https://photos.zillowstatic.com/fp/422614fdf65f9b057810f2c962bf6655-p_d.jpg",
        "https://photos.zillowstatic.com/fp/d1fa90d3c681762dcdf96593dec168fc-p_d.jpg",
        "https://photos.zillowstatic.com/fp/4235724c592574801a3a6a65606bc935-p_d.jpg",
        "https://photos.zillowstatic.com/fp/d1728d009451584482b7f2d149541598-p_d.jpg",
        "https://photos.zillowstatic.com/fp/d36ebc52f06b1fbaf6a5b169ca90a815-p_d.jpg",
        "https://photos.zillowstatic.com/fp/d054ee38e9a90bf207eb49e8c78c5254-p_d.jpg",
        "https://photos.zillowstatic.com/fp/376443a96cee49313aca94978fa0eac3-p_d.jpg",
        "https://photos.zillowstatic.com/fp/7b2c09b42e59f072046da0e09ecec7b3-p_d.jpg",
        "https://photos.zillowstatic.com/fp/e203f3102aa553131b6118f113e3b175-p_d.jpg",
        "https://photos.zillowstatic.com/fp/d64623732f0f23600aad3796ec2fd39e-p_d.jpg",
        "https://photos.zillowstatic.com/fp/72fca8362014bed583790e810fb3d59b-p_d.jpg",
        "https://photos.zillowstatic.com/fp/f278dcb88d395aedc3b30710a509a995-p_d.jpg",
        "https://photos.zillowstatic.com/fp/03efb512c668acf31b1cec426bb62831-p_d.jpg",
        "https://photos.zillowstatic.com/fp/6141d3fed564c5142eb8444642760929-p_d.jpg",
        "https://photos.zillowstatic.com/fp/589d24cc219764888c8a6d3e87e5b55e-p_d.jpg",
        "https://photos.zillowstatic.com/fp/57dc2bf4e61ccb4dcb7cfbaae03de13e-p_d.jpg",
        "https://photos.zillowstatic.com/fp/42f1b0809f7a0b917e10a7f91358b601-p_d.jpg",
        "https://photos.zillowstatic.com/fp/9ae85cf5097d3e3cec12cf465036b0d2-p_d.jpg",
        "https://photos.zillowstatic.com/fp/8b1a2685576c2b3fccc4b552d4aa1381-p_d.jpg",
        "https://photos.zillowstatic.com/fp/993b8e3f8d2e1e147ec1ab566071d2b0-p_d.jpg",
        "https://photos.zillowstatic.com/fp/822007302cfe7596ca38af189b32a6a8-p_d.jpg",
        "https://photos.zillowstatic.com/fp/0a9146ec87acf31aedbe001624b91b16-p_d.jpg",
        "https://photos.zillowstatic.com/fp/d30b06af7f6b5a43eb05461cd1929835-p_d.jpg"
      ],
      "homeStatus": "FOR_SALE",
      "price": 1250,
      "rating": 2,
      "type": "Villa",
      "address": {
        "streetAddress": "2656 Banbury Pl",
        "city": "Los Angeles",
        "state": "CA",
        "zipcode": "90065",
        "neighborhood": null,
        "community": null,
        "subdivision": null
      },
      "yearBuilt": 1948,
      "bedrooms": 1,
      "bathrooms": 1,
      "livingArea": 640,
      "url": "https://www.zillow.com/homedetails/2656-Banbury-Pl-Los-Angeles-CA-90065/20764561_zpid/",
      "_id": "hx30ytymdlj",
      "__index": 9
    },
    {
      "photos": [
        "https://photos.zillowstatic.com/fp/8e0497f83a22308c1286efb4f03254e5-p_d.jpg",
        "https://photos.zillowstatic.com/fp/5eb3fab899f260a2afedebd7efd4348a-p_d.jpg",
        "https://photos.zillowstatic.com/fp/94f30123a9e1a545dc5316492aa66074-p_d.jpg",
        "https://photos.zillowstatic.com/fp/92012b00cab5f8820459e21d3293e21e-p_d.jpg",
        "https://photos.zillowstatic.com/fp/9536224da8868ce26123c37c095eedd1-p_d.jpg",
        "https://photos.zillowstatic.com/fp/ffc29d0d1a13b8fa4737ebfce04d3a74-p_d.jpg",
        "https://photos.zillowstatic.com/fp/cfcf5a59c96407635e7808278829b2c4-p_d.jpg",
        "https://photos.zillowstatic.com/fp/5dc39648c1decc6f8769437eb10473ea-p_d.jpg",
        "https://photos.zillowstatic.com/fp/8ad6340e1da67b494edae321865447bf-p_d.jpg",
        "https://photos.zillowstatic.com/fp/5704d4614416328a70ff1fc34cd7912a-p_d.jpg",
        "https://photos.zillowstatic.com/fp/0c1ab33b41cc15408d7be8099bbef88f-p_d.jpg",
        "https://photos.zillowstatic.com/fp/767ca3b7a3334f955ad711f17a782b9a-p_d.jpg",
        "https://photos.zillowstatic.com/fp/1dfa4d559e4d69d003aa1f48890a095a-p_d.jpg",
        "https://photos.zillowstatic.com/fp/e7ab41bdb2333b1f98b851badd7fe022-p_d.jpg",
        "https://photos.zillowstatic.com/fp/53d18d8951c4affd883ac2a99f965fa2-p_d.jpg",
        "https://photos.zillowstatic.com/fp/cb70800d9fb1f858ba8219e3730ffdf2-p_d.jpg",
        "https://photos.zillowstatic.com/fp/0a7f1b70eafc37599e736d757abe843e-p_d.jpg",
        "https://photos.zillowstatic.com/fp/2ab7c641d2b132b6fd610217f2f15923-p_d.jpg",
        "https://photos.zillowstatic.com/fp/fd378c982d352b063254f06a3292c305-p_d.jpg",
        "https://photos.zillowstatic.com/fp/3515bae6bd3402e74fb353688fb7f7f3-p_d.jpg",
        "https://photos.zillowstatic.com/fp/9aca41d0d0f61f83532e02773dd7d6f2-p_d.jpg",
        "https://photos.zillowstatic.com/fp/95d5f829666d765b75a6afa53609e1a3-p_d.jpg",
        "https://photos.zillowstatic.com/fp/dee38d0fde1f50ad960a571f7dfef040-p_d.jpg"
      ],
      "homeStatus": "FOR_SALE",
      "price": 697,
      "rating": 3.5,
      "type": "Condo",
      "address": {
        "streetAddress": "4235 Mary Ellen Ave UNIT 102",
        "city": "Studio City",
        "state": "CA",
        "zipcode": "91604",
        "neighborhood": null,
        "community": null,
        "subdivision": null
      },
      "yearBuilt": 1990,
      "bedrooms": 2,
      "bathrooms": 3,
      "livingArea": 1529,
      "url": "https://www.zillow.com/homedetails/4235-Mary-Ellen-Ave-UNIT-102-Studio-City-CA-91604/20029506_zpid/",
      "_id": "9yhl39mo124",
      "__index": 10
    },
    {
      "photos": [
        "https://photos.zillowstatic.com/fp/c2bf6879004e0020e4ee55d4e0d9d82c-p_d.jpg",
        "https://photos.zillowstatic.com/fp/c4ed12b08b4f90ade460b1028084712c-p_d.jpg",
        "https://photos.zillowstatic.com/fp/9822e2f35fc271798f1b25190a82f4e8-p_d.jpg",
        "https://photos.zillowstatic.com/fp/a1bc1dae105a3ae0d23c10edb8543611-p_d.jpg",
        "https://photos.zillowstatic.com/fp/d3ce616ec779356d64eba7dd7e1e0f5d-p_d.jpg",
        "https://photos.zillowstatic.com/fp/0af5831620421ad772f7af402dd5be70-p_d.jpg",
        "https://photos.zillowstatic.com/fp/73fbe2015c5c2dd11bdb6bbd696a7ce0-p_d.jpg",
        "https://photos.zillowstatic.com/fp/301c5d9dd6645ed8c27b1aee7df47e1d-p_d.jpg",
        "https://photos.zillowstatic.com/fp/76188451d74a72ab947fa57373654508-p_d.jpg",
        "https://photos.zillowstatic.com/fp/dbe02ee403d885a06bb0279edc9c891d-p_d.jpg",
        "https://photos.zillowstatic.com/fp/45a0a47574685ad144d1a9cb57a4eda3-p_d.jpg",
        "https://photos.zillowstatic.com/fp/a85a8ed0d4193c7ef7c9d7cae558d7c8-p_d.jpg",
        "https://photos.zillowstatic.com/fp/bc7825eb1fca05a40faf25a990855486-p_d.jpg",
        "https://photos.zillowstatic.com/fp/0e572312ce8cbc2e510d3a69649efe0b-p_d.jpg",
        "https://photos.zillowstatic.com/fp/47ae76103d66fc0959c2961102171f74-p_d.jpg",
        "https://photos.zillowstatic.com/fp/4572a2cdd3ea3dd00f2472f077db1719-p_d.jpg",
        "https://photos.zillowstatic.com/fp/2faf4c3962703ea19c0ade8b83dbd3e1-p_d.jpg",
        "https://photos.zillowstatic.com/fp/7b13e385fb355335ad68ed576f52dc57-p_d.jpg",
        "https://photos.zillowstatic.com/fp/934eda22cda903f91f007e275a0acc6f-p_d.jpg",
        "https://photos.zillowstatic.com/fp/71e827a9dedfcf89ec16a3fa5e6fae51-p_d.jpg",
        "https://photos.zillowstatic.com/fp/f6aaf5c1bbaedf6a4efd1f7c9827031b-p_d.jpg",
        "https://photos.zillowstatic.com/fp/23fb05abf95d2c958fe238c5b5acf7df-p_d.jpg",
        "https://photos.zillowstatic.com/fp/b437a42ef6d341365675b2daf6dc2977-p_d.jpg"
      ],
      "homeStatus": "FOR_SALE",
      "price": 5490,
      "rating": 8.5,
      "type": "Guest House",
      "address": {
        "streetAddress": "15652 Index St",
        "city": "Granada Hills",
        "state": "CA",
        "zipcode": "91344",
        "neighborhood": null,
        "community": null,
        "subdivision": null
      },
      "yearBuilt": 1955,
      "bedrooms": 5,
      "bathrooms": 3,
      "livingArea": 1884,
      "url": "https://www.zillow.com/homedetails/15652-Index-St-Granada-Hills-CA-91344/20139093_zpid/",
      "_id": "x1p5s4kozsc",
      "__index": 11
    },
    {
      "photos": [
        "https://photos.zillowstatic.com/fp/6d8f93c5f0039420c3dfc85cff5835d7-p_d.jpg",
        "https://photos.zillowstatic.com/fp/d2b4ca813b4780c39cdc0c3a9b83a34f-p_d.jpg",
        "https://photos.zillowstatic.com/fp/bdaabe8c7c26a189df7a259a800a74d6-p_d.jpg",
        "https://photos.zillowstatic.com/fp/7c7f8689f2088e25be5690b0784c76ee-p_d.jpg",
        "https://photos.zillowstatic.com/fp/64d651f4562cbb9a235de363a56fb8f7-p_d.jpg",
        "https://photos.zillowstatic.com/fp/a817a87b975709eb16c9c2140f470557-p_d.jpg",
        "https://photos.zillowstatic.com/fp/a4f175001f8d8cf0b0a329ce20561294-p_d.jpg",
        "https://photos.zillowstatic.com/fp/a54547b64df75ad378cbcca4b01a2a9d-p_d.jpg",
        "https://photos.zillowstatic.com/fp/ddee4ebfd595ab219acdf66339491797-p_d.jpg",
        "https://photos.zillowstatic.com/fp/f73b02604b33d71548dd154915ebb3b8-p_d.jpg",
        "https://photos.zillowstatic.com/fp/61792c4e396c6a76e64636635aa4202b-p_d.jpg",
        "https://photos.zillowstatic.com/fp/8ebdc71ad0c510f7563e08c15654f6be-p_d.jpg",
        "https://photos.zillowstatic.com/fp/d5c1e2a72e8c0b380d8b70a2859a0018-p_d.jpg",
        "https://photos.zillowstatic.com/fp/29f46912f0d801ab4f698f5703eab8b1-p_d.jpg",
        "https://photos.zillowstatic.com/fp/7f84086afe20cf470d8d603a05c5db75-p_d.jpg",
        "https://photos.zillowstatic.com/fp/1490f06a923c11a151c2ff4a47558086-p_d.jpg",
        "https://photos.zillowstatic.com/fp/cdd317375def919b4b31a9e0f0e0d8be-p_d.jpg",
        "https://photos.zillowstatic.com/fp/1184fa4d6a9d13f79f788f22e6b79bd1-p_d.jpg",
        "https://photos.zillowstatic.com/fp/f66ee994214bb8e3189941d97e8d982f-p_d.jpg",
        "https://photos.zillowstatic.com/fp/2fe7b120f1f16843d51a696adc21bd7e-p_d.jpg",
        "https://photos.zillowstatic.com/fp/17c6cf1e444e8defe5048b635c71cec2-p_d.jpg",
        "https://photos.zillowstatic.com/fp/b362246ad6eb074e36e25933bbba0ea9-p_d.jpg",
        "https://photos.zillowstatic.com/fp/6018e0402b4a6ab4a56f9f5f565cf5e0-p_d.jpg",
        "https://photos.zillowstatic.com/fp/a3a737a3e7f30009be55252b890769ae-p_d.jpg",
        "https://photos.zillowstatic.com/fp/6b0626ed78a1a253ca15abd2592f1c54-p_d.jpg",
        "https://photos.zillowstatic.com/fp/5157ba9a8b547e2af221e802f22e7abc-p_d.jpg",
        "https://photos.zillowstatic.com/fp/8ed21e9db912e4d85badc5150ec64485-p_d.jpg",
        "https://photos.zillowstatic.com/fp/b8b9622388056581da724dd1d458256f-p_d.jpg",
        "https://photos.zillowstatic.com/fp/04feb9682854c0fe8fff662dc32b0f6a-p_d.jpg"
      ],
      "homeStatus": "RECENTLY_SOLD",
      "price": 9343,
      "rating": 3,
      "type": "Apartment",
      "address": {
        "streetAddress": "23819 Welby Way",
        "city": "West Hills",
        "state": "CA",
        "zipcode": "91307",
        "neighborhood": null,
        "community": null,
        "subdivision": null
      },
      "yearBuilt": 1959,
      "bedrooms": 4,
      "bathrooms": 2,
      "livingArea": 1570,
      "url": "https://www.zillow.com/homedetails/23819-Welby-Way-West-Hills-CA-91307/19874113_zpid/",
      "_id": "t26iid3o17i",
      "__index": 12
    },
    {
      "photos": [
        "https://photos.zillowstatic.com/fp/4cf051d98f48cc5494817f03472c7485-p_d.jpg",
        "https://photos.zillowstatic.com/fp/d17512aa5bbcd4348652789551a340d5-p_d.jpg",
        "https://photos.zillowstatic.com/fp/fa7127006837deda504d68ba7a3e5d10-p_d.jpg",
        "https://photos.zillowstatic.com/fp/bb8661704770c875caf1a6eae824a011-p_d.jpg",
        "https://photos.zillowstatic.com/fp/4399399ede30146beee3417ba9ee3976-p_d.jpg",
        "https://photos.zillowstatic.com/fp/2894ef9c36c6cf60a0bbb10ef9fe6184-p_d.jpg",
        "https://photos.zillowstatic.com/fp/127c4408a333da9eed72e370f9d77602-p_d.jpg",
        "https://photos.zillowstatic.com/fp/bf69ec4d4de10c908b6f659ad79546dc-p_d.jpg"
      ],
      "homeStatus": "FOR_SALE",
      "price": 3715,
      "rating": 9.5,
      "type": "Villa",
      "address": {
        "streetAddress": "20234 Cantara St UNIT 136",
        "city": "Winnetka",
        "state": "CA",
        "zipcode": "91306",
        "neighborhood": null,
        "community": null,
        "subdivision": null
      },
      "yearBuilt": 1960,
      "bedrooms": 0,
      "bathrooms": 0,
      "livingArea": 444,
      "url": "https://www.zillow.com/homedetails/20234-Cantara-St-UNIT-136-Winnetka-CA-91306/19907748_zpid/",
      "_id": "4bvhoy4g4kn",
      "__index": 13
    },
    {
      "photos": [
        "https://photos.zillowstatic.com/fp/655f872312e4a0e482f11a1ed851a985-p_d.jpg"
      ],
      "homeStatus": "RECENTLY_SOLD",
      "price": 2998,
      "rating": 5.5,
      "type": "House",
      "address": {
        "streetAddress": "6236 Sale Ave",
        "city": "Woodland Hills",
        "state": "CA",
        "zipcode": "91367",
        "neighborhood": null,
        "community": null,
        "subdivision": null
      },
      "yearBuilt": 1963,
      "bedrooms": 4,
      "bathrooms": 3,
      "livingArea": 2497,
      "url": "https://www.zillow.com/homedetails/6236-Sale-Ave-Woodland-Hills-CA-91367/19877668_zpid/",
      "_id": "u8d73nip99",
      "__index": 14
    },
    {
      "photos": [
        "https://photos.zillowstatic.com/fp/2576eb7f392931cd483dad45c7e19710-p_d.jpg",
        "https://photos.zillowstatic.com/fp/092636c4edfa19d9d05ebb1226eab599-p_d.jpg",
        "https://photos.zillowstatic.com/fp/7ef1cc7be7966cbc21f3310539b18c2d-p_d.jpg",
        "https://photos.zillowstatic.com/fp/0d74b32af2889df768dc68b76acf6737-p_d.jpg",
        "https://photos.zillowstatic.com/fp/5632b49c8af02a7fd103c3a42c5fa069-p_d.jpg",
        "https://photos.zillowstatic.com/fp/340b76abe052655881887968410c4028-p_d.jpg",
        "https://photos.zillowstatic.com/fp/6fcd61b7c6a81725dbbe5dce5db29223-p_d.jpg",
        "https://photos.zillowstatic.com/fp/5497b99a8857ec21ab15b9316f3ee2bb-p_d.jpg",
        "https://photos.zillowstatic.com/fp/e64a9bbf949c3f295849ec9e3597c1c1-p_d.jpg",
        "https://photos.zillowstatic.com/fp/09e95b87b8eb87d6ef65dd5793973ba7-p_d.jpg",
        "https://photos.zillowstatic.com/fp/eb44922e68eee64cd78738a481acc055-p_d.jpg",
        "https://photos.zillowstatic.com/fp/2c5d4fbc848ac5a80aba89e05ebe0b0d-p_d.jpg",
        "https://photos.zillowstatic.com/fp/22d44ebb54f61fd4b76aea2ae5b652ca-p_d.jpg",
        "https://photos.zillowstatic.com/fp/5b2230980e26772d218abda3fcc5514e-p_d.jpg",
        "https://photos.zillowstatic.com/fp/5fef0ea140582a56d9f6ade3f9d7c653-p_d.jpg",
        "https://photos.zillowstatic.com/fp/609bf658a7072bc1c3b79d47cb493553-p_d.jpg",
        "https://photos.zillowstatic.com/fp/2d21e893b93e4512fc500ead3f02d8e0-p_d.jpg",
        "https://photos.zillowstatic.com/fp/49890ace8ef43a5ccc91d7a24a9d6d6f-p_d.jpg",
        "https://photos.zillowstatic.com/fp/e7cb05b8d735368a6b8db8b00fd19b8d-p_d.jpg",
        "https://photos.zillowstatic.com/fp/80875127e913dec1431c2ae8226bacad-p_d.jpg",
        "https://photos.zillowstatic.com/fp/bc713c0969f50ada96d45a7f4b103bfa-p_d.jpg",
        "https://photos.zillowstatic.com/fp/18ad2b4b5dbe558598c9b71f9f4a2728-p_d.jpg",
        "https://photos.zillowstatic.com/fp/9b25ca2443466135dfb17e71b45a5b57-p_d.jpg",
        "https://photos.zillowstatic.com/fp/1029f21d652a8f336c81faa5090e183c-p_d.jpg",
        "https://photos.zillowstatic.com/fp/a7cf9e865388c0092816d7771f3fac35-p_d.jpg",
        "https://photos.zillowstatic.com/fp/663fb9374f587f288438fd814fe56049-p_d.jpg",
        "https://photos.zillowstatic.com/fp/cdbe4f29b893cc6e3e6d80d4c26aa0af-p_d.jpg",
        "https://photos.zillowstatic.com/fp/954c1f42738457af6001cae605088812-p_d.jpg",
        "https://photos.zillowstatic.com/fp/75c7910ff973f116867274256e5e7767-p_d.jpg",
        "https://photos.zillowstatic.com/fp/60ad98d0a20ea22790b6ffa5efbf4565-p_d.jpg",
        "https://photos.zillowstatic.com/fp/264ce88c7dc21df67ab0296bef805b24-p_d.jpg",
        "https://photos.zillowstatic.com/fp/053432e12f886848e81238939c3b8b51-p_d.jpg",
        "https://photos.zillowstatic.com/fp/aecb2cd9e4d4fc715b3da2f8158e477f-p_d.jpg",
        "https://photos.zillowstatic.com/fp/856cbaf9bf7e5cde4f49bcca8710e6e2-p_d.jpg"
      ],
      "homeStatus": "FOR_SALE",
      "price": 4287,
      "rating": 5,
      "type": "House",
      "address": {
        "streetAddress": "5231 Franklin Ave",
        "city": "Los Angeles",
        "state": "CA",
        "zipcode": "90027",
        "neighborhood": null,
        "community": null,
        "subdivision": null
      },
      "yearBuilt": 1921,
      "bedrooms": 5,
      "bathrooms": 4,
      "livingArea": 4743,
      "url": "https://www.zillow.com/homedetails/5231-Franklin-Ave-Los-Angeles-CA-90027/20809661_zpid/",
      "_id": "bneozchwrva",
      "__index": 15
    },
    {
      "photos": [
        "https://photos.zillowstatic.com/fp/71c47e73a6db9e4d9dc1e29933afb045-p_d.jpg",
        "https://photos.zillowstatic.com/fp/a4d79e54679d86273ffd8cfca0b93bda-p_d.jpg",
        "https://photos.zillowstatic.com/fp/a881246dd971cc1870b3ee390518d21d-p_d.jpg",
        "https://photos.zillowstatic.com/fp/c5fe00563bb1f49d504e370bbba3386b-p_d.jpg",
        "https://photos.zillowstatic.com/fp/84003894038f73f1587cdb082dbdb86e-p_d.jpg",
        "https://photos.zillowstatic.com/fp/fa298243813a35b393d4464562af707d-p_d.jpg",
        "https://photos.zillowstatic.com/fp/02e3c266d28db4edb647db016da1b563-p_d.jpg",
        "https://photos.zillowstatic.com/fp/5f58ddaa3bfdcb3aa7a5d20f37dd6ca9-p_d.jpg",
        "https://photos.zillowstatic.com/fp/9a1d1754ab0fc4e3a8ed0164811d95c0-p_d.jpg",
        "https://photos.zillowstatic.com/fp/8edb3c2fe51359ca4f080ef47649ba42-p_d.jpg",
        "https://photos.zillowstatic.com/fp/1af87bacf926b57fcd136b99744defad-p_d.jpg",
        "https://photos.zillowstatic.com/fp/d91187c085417ff54a0a127292cae64a-p_d.jpg",
        "https://photos.zillowstatic.com/fp/6eddc307b4407fa41dc498873cb21f4f-p_d.jpg",
        "https://photos.zillowstatic.com/fp/0d8c3e204187e5227a1d183c88a8e0ab-p_d.jpg",
        "https://photos.zillowstatic.com/fp/5b5b224cb4de48c807dd0f5f5de5fb2b-p_d.jpg",
        "https://photos.zillowstatic.com/fp/cb1faf3d6c18bc5cafa5cb2ee9883f87-p_d.jpg",
        "https://photos.zillowstatic.com/fp/df035d0115b245e45f47c3b85ef54b80-p_d.jpg",
        "https://photos.zillowstatic.com/fp/5d448c2d2e7fbdc6d566625fa356d97d-p_d.jpg"
      ],
      "homeStatus": "RECENTLY_SOLD",
      "price": 9052,
      "rating": 9,
      "type": "Apartment",
      "address": {
        "streetAddress": "8018 Hesperia Ave",
        "city": "Reseda",
        "state": "CA",
        "zipcode": "91335",
        "neighborhood": null,
        "community": null,
        "subdivision": null
      },
      "yearBuilt": 1954,
      "bedrooms": 4,
      "bathrooms": 2,
      "livingArea": 1479,
      "url": "https://www.zillow.com/homedetails/8018-Hesperia-Ave-Reseda-CA-91335/19902584_zpid/",
      "_id": "d2amev8yli",
      "__index": 16
    },
    {
      "photos": [
        "https://photos.zillowstatic.com/fp/d2b4ca813b4780c39cdc0c3a9b83a34f-p_d.jpg",

      ],
      "homeStatus": "FOR_SALE",
      "price": 7170,
      "rating": 7,
      "type": "Condo",
      "address": {
        "streetAddress": "10790 Wilshire Blvd APT 1003",
        "city": "Los Angeles",
        "state": "CA",
        "zipcode": "90024",
        "neighborhood": null,
        "community": null,
        "subdivision": null
      },
      "yearBuilt": 1989,
      "bedrooms": 2,
      "bathrooms": 3,
      "livingArea": 2875,
      "url": "https://www.zillow.com/homedetails/10790-Wilshire-Blvd-APT-1003-Los-Angeles-CA-90024/20504758_zpid/",
      "_id": "v1qr79j5jo",
      "__index": 17
    },
    {
      "photos": [
        "https://photos.zillowstatic.com/fp/68f43ff5f81c37b91d898cee07db0c43-p_d.jpg",
        "https://photos.zillowstatic.com/fp/767337d69cba93e6cf3d6337d49908b7-p_d.jpg",
        "https://photos.zillowstatic.com/fp/6e1eb6c842c0f161aa215f0ff1fbd6cd-p_d.jpg",
        "https://photos.zillowstatic.com/fp/bd652357ebd904829a7ca22bc0cbb7c5-p_d.jpg",
        "https://photos.zillowstatic.com/fp/023110e2c4c2ba2553609eeb75f98b58-p_d.jpg",
        "https://photos.zillowstatic.com/fp/e1515b1e21bfe9d8bd58fe9e120a2924-p_d.jpg",
        "https://photos.zillowstatic.com/fp/b0955d2bb0a953d6a9431bb50cee73b1-p_d.jpg",
        "https://photos.zillowstatic.com/fp/60683cbc54c2547d0e47e7c6dcbd4d3b-p_d.jpg",
        "https://photos.zillowstatic.com/fp/08f4f4bcb9aeac58c80b7065e799f240-p_d.jpg",
        "https://photos.zillowstatic.com/fp/921023373e71d2eeb9c7c134b9053d68-p_d.jpg",
        "https://photos.zillowstatic.com/fp/2c8e8bca40461717d36d5979d15a8a28-p_d.jpg",
        "https://photos.zillowstatic.com/fp/636a1c5134e2d99df4517b650f391f74-p_d.jpg",
        "https://photos.zillowstatic.com/fp/e88130b516026ad1873ad3bee68c50a8-p_d.jpg",
        "https://photos.zillowstatic.com/fp/37ba11164f064f02c64b0e3695b1f3c7-p_d.jpg",
        "https://photos.zillowstatic.com/fp/06368e96a181f906ff7925f22855bbe5-p_d.jpg",
        "https://photos.zillowstatic.com/fp/19a5e7dc1a8ac7bdf1c42099bed035e6-p_d.jpg",
        "https://photos.zillowstatic.com/fp/b89206d58cce67065f32666d55da73c7-p_d.jpg",
        "https://photos.zillowstatic.com/fp/18841d1f6f63f2e996302e74b399ccdf-p_d.jpg",
        "https://photos.zillowstatic.com/fp/bf3d7f996658077478a4adae948da0d6-p_d.jpg",
        "https://photos.zillowstatic.com/fp/e0cd1526b1be18aa3cb858a888981bdf-p_d.jpg",
        "https://photos.zillowstatic.com/fp/5abf6f38ba5dac895f10bebb60959099-p_d.jpg",
        "https://photos.zillowstatic.com/fp/8def2161f7ff4f1e5630c61aa43f0e6e-p_d.jpg",
        "https://photos.zillowstatic.com/fp/e38fbac46a7d9f99cdef35f1cc2e8a18-p_d.jpg",
        "https://photos.zillowstatic.com/fp/403ee75604bd1c7dfcd4148d225248c6-p_d.jpg",
        "https://photos.zillowstatic.com/fp/47db63c682ea4d839a118d23d06b1c95-p_d.jpg",
        "https://photos.zillowstatic.com/fp/585d46ef3e8addd4becb1d8dded7f087-p_d.jpg",
        "https://photos.zillowstatic.com/fp/02a2d01d414395f8cb84ef032fffaa81-p_d.jpg",
        "https://photos.zillowstatic.com/fp/7ccb769388b78d457af065c7db745919-p_d.jpg",
        "https://photos.zillowstatic.com/fp/bd4107879ec603d016785a86d77088c2-p_d.jpg",
        "https://photos.zillowstatic.com/fp/ce3a908cf85ee25a527e3f09a40c93f6-p_d.jpg",
        "https://photos.zillowstatic.com/fp/7ada8a53e2509784142b56a147a5c54f-p_d.jpg",
        "https://photos.zillowstatic.com/fp/46d007e81b9daa00bced1abc64949359-p_d.jpg",
        "https://photos.zillowstatic.com/fp/5015a77bd190ea424f11a91905e6f676-p_d.jpg"
      ],
      "homeStatus": "PRE_FORECLOSURE",
      "price": 1823,
      "rating": 6,
      "type": "Guest House",
      "address": {
        "streetAddress": "14827 Victory Blvd",
        "city": "Van Nuys",
        "state": "CA",
        "zipcode": "91411",
        "neighborhood": null,
        "community": null,
        "subdivision": null
      },
      "yearBuilt": 2022,
      "bedrooms": 28,
      "bathrooms": 29,
      "livingArea": 14279,
      "url": "https://www.zillow.com/homedetails/14827-Victory-Blvd-Van-Nuys-CA-91411/19969380_zpid/",
      "_id": "qy3v2zn65tr",
      "__index": 18
    },
    {
      "photos": [
        "https://maps.googleapis.com/maps/api/streetview?location=3669+S+Saint+Andrews+Pl%2C+Los+Angeles%2C+CA+90018&size=400x300&key=AIzaSyARFMLB1na-BBWf7_R3-5YOQQaHqEJf6RQ&source=outdoor&&signature=05-_lgJRqMT6loz0rB4nXTAWt0Y="
      ],
      "homeStatus": "FOR_SALE",
      "price": 4822,
      "rating": 1.5,
      "type": "Villa",
      "address": {
        "streetAddress": "3669 S Saint Andrews Pl",
        "city": "Los Angeles",
        "state": "CA",
        "zipcode": "90018",
        "neighborhood": null,
        "community": null,
        "subdivision": null
      },
      "yearBuilt": 1923,
      "bedrooms": 2,
      "bathrooms": 1,
      "livingArea": 812,
      "url": "https://www.zillow.com/homedetails/3669-S-Saint-Andrews-Pl-Los-Angeles-CA-90018/20584439_zpid/",
      "_id": "xmg52152cie",
      "__index": 19
    },
    {
      "photos": [
        "https://photos.zillowstatic.com/fp/fe0f98035d607d8c23ba8a7b497cf7e6-p_d.jpg"
      ],
      "homeStatus": "RECENTLY_SOLD",
      "price": 1100,
      "rating": 2.5,
      "type": "House",
      "address": {
        "streetAddress": "14325 Killion St",
        "city": "Van Nuys",
        "state": "CA",
        "zipcode": "91401",
        "neighborhood": null,
        "community": null,
        "subdivision": null
      },
      "yearBuilt": 1954,
      "bedrooms": 4,
      "bathrooms": 3,
      "livingArea": 1978,
      "url": "https://www.zillow.com/homedetails/14325-Killion-St-Van-Nuys-CA-91401/19972828_zpid/",
      "_id": "2uiwpugnofd",
      "__index": 20
    },
    {
      "photos": [
        "https://photos.zillowstatic.com/fp/df864ddd027d9459bd52fe954812bc02-p_d.jpg",
        "https://photos.zillowstatic.com/fp/cda54e682dc846bc141e926d88ccdbb0-p_d.jpg",
        "https://photos.zillowstatic.com/fp/d1f26a993cb79a4e58a872fb4131dd1b-p_d.jpg",
        "https://photos.zillowstatic.com/fp/c9f6456d4a1e236eb641aecc4becda35-p_d.jpg",
        "https://photos.zillowstatic.com/fp/2ee41429425551c90c233518fd9926c4-p_d.jpg",
        "https://photos.zillowstatic.com/fp/1354ae3a1e5bdaa5cfc18cd16f0a9f4c-p_d.jpg",
        "https://photos.zillowstatic.com/fp/1ebc84e118dd805342f69402b062f4ce-p_d.jpg",
        "https://photos.zillowstatic.com/fp/21be7f687ef132629a30d1e184c24cec-p_d.jpg",
        "https://photos.zillowstatic.com/fp/18667783a654a8711d8440316c1dea8f-p_d.jpg",
        "https://photos.zillowstatic.com/fp/ea7fd5406c18a6acda616d3bf58c3636-p_d.jpg",
        "https://photos.zillowstatic.com/fp/bda507f2cd0d7a05359feb1952016e2e-p_d.jpg",
        "https://photos.zillowstatic.com/fp/ada29dfaf9c4cb06a1ea8774ba3138e3-p_d.jpg",
        "https://photos.zillowstatic.com/fp/6549627c562f41177fb35446cd8ecb68-p_d.jpg",
        "https://photos.zillowstatic.com/fp/89e425b21ce1d9a22585591ac4592a19-p_d.jpg",
        "https://photos.zillowstatic.com/fp/5073898557d310ca9bf1e5d70d48fedf-p_d.jpg",
        "https://photos.zillowstatic.com/fp/9c2de5f6827a71c532899e7001a9adad-p_d.jpg",
        "https://photos.zillowstatic.com/fp/4cc988a0b1fcd43ac2b39f457124b8d3-p_d.jpg",
        "https://photos.zillowstatic.com/fp/75c3c5d5393f26269b76ce9a4351dc6b-p_d.jpg"
      ],
      "homeStatus": "FOR_SALE",
      "price": 575,
      "rating": 3.5,
      "type": "Guest House",
      "address": {
        "streetAddress": "12910 Walsh Ave #4",
        "city": "Los Angeles",
        "state": "CA",
        "zipcode": "90066",
        "neighborhood": null,
        "community": null,
        "subdivision": null
      },
      "yearBuilt": 1957,
      "bedrooms": 2,
      "bathrooms": 1,
      "livingArea": 705,
      "url": "https://www.zillow.com/homedetails/12910-Walsh-Ave-4-Los-Angeles-CA-90066/2077929659_zpid/",
      "_id": "cq74or37pl",
      "__index": 21
    },
    {
      "photos": [
        "https://photos.zillowstatic.com/fp/8d8e0f548fbf41bb0fd479a49810f483-p_d.jpg",
        "https://photos.zillowstatic.com/fp/54c9d1b02b915b6343075d6784f67d13-p_d.jpg",
        "https://photos.zillowstatic.com/fp/e6cbe6ca5dd941f57bf8b2b7e3fba660-p_d.jpg",
        "https://photos.zillowstatic.com/fp/d9fb6d69615170225fe13124c1dda7fd-p_d.jpg",
        "https://photos.zillowstatic.com/fp/50714091fa6a8e2ce96415847d844a93-p_d.jpg",
        "https://photos.zillowstatic.com/fp/95853441c9aba680142f9f4c895e1a5b-p_d.jpg",
        "https://photos.zillowstatic.com/fp/2160a856ecb7408de49a927459c3cd17-p_d.jpg",
        "https://photos.zillowstatic.com/fp/cc29fb732f7ce4a6e3bb6e7f0d1ce303-p_d.jpg",
        "https://photos.zillowstatic.com/fp/f0d3986fb00a64c54a7a8462343299e7-p_d.jpg",
        "https://photos.zillowstatic.com/fp/7f23bab194f877a1cc92bfeffb9133dc-p_d.jpg",
        "https://photos.zillowstatic.com/fp/57920030ea6b910b743b931eee119934-p_d.jpg",
        "https://photos.zillowstatic.com/fp/b79700f96948742aaebf7c9bb076fc32-p_d.jpg",
        "https://photos.zillowstatic.com/fp/14f5cce02d09d9b1ab7122f46b29de60-p_d.jpg",
        "https://photos.zillowstatic.com/fp/b106a864855db4c454a4f6d3af88bb45-p_d.jpg"
      ],
      "homeStatus": "FOR_SALE",
      "price": 1750,
      "rating": 10,
      "type": "Condo",
      "address": {
        "streetAddress": "8163 Redlands St APT 43",
        "city": "Playa Del Rey",
        "state": "CA",
        "zipcode": "90293",
        "neighborhood": null,
        "community": null,
        "subdivision": null
      },
      "yearBuilt": 1973,
      "bedrooms": 1,
      "bathrooms": 1,
      "livingArea": 711,
      "url": "https://www.zillow.com/homedetails/8163-Redlands-St-APT-43-Playa-Del-Rey-CA-90293/20387094_zpid/",
      "_id": "0t7sd4zedllp",
      "__index": 22
    },
    {
      "photos": [
        "https://photos.zillowstatic.com/fp/3e68bdf7994935f9848b2a1b64864a67-p_d.jpg",
        "https://photos.zillowstatic.com/fp/8b9a97068353811be3f56e00e55a9ca5-p_d.jpg",
        "https://photos.zillowstatic.com/fp/2ec609273e5d8174a09393f853695cbd-p_d.jpg",
        "https://photos.zillowstatic.com/fp/23d7b2b4dbf24da1e0728170e99da6c8-p_d.jpg",
        "https://photos.zillowstatic.com/fp/f50d1fb323e3d4f49fb67566e3bb9dcd-p_d.jpg",
        "https://photos.zillowstatic.com/fp/82861e968ced14cd63d04c68ba1ca4c5-p_d.jpg",
        "https://photos.zillowstatic.com/fp/2ae2a30c2aabc58af184c198a7ea2dec-p_d.jpg",
        "https://photos.zillowstatic.com/fp/f4c99de293841acf6622fe77f7f39b0c-p_d.jpg",
        "https://photos.zillowstatic.com/fp/e2446a7b200b5e74b574f483530cafd7-p_d.jpg",
        "https://photos.zillowstatic.com/fp/d001a7b85ea96379ea6f2990f7a44973-p_d.jpg",
        "https://photos.zillowstatic.com/fp/efd45e6d050f9d43f753def7e945fe26-p_d.jpg",
        "https://photos.zillowstatic.com/fp/6cb1208281d7228ccde8a1ce5a5a0712-p_d.jpg",
        "https://photos.zillowstatic.com/fp/2c58705e86f67f1444be29d657a84267-p_d.jpg",
        "https://photos.zillowstatic.com/fp/03f751822d8cad9e3eee0d238e649ec7-p_d.jpg",
        "https://photos.zillowstatic.com/fp/d50a8b19a103102cf871fe1b7df1fe8c-p_d.jpg",
        "https://photos.zillowstatic.com/fp/c42bdee4491d6233d6858909dd0b6550-p_d.jpg",
        "https://photos.zillowstatic.com/fp/86c4074240d02b1660f959aea704589a-p_d.jpg",
        "https://photos.zillowstatic.com/fp/0d62b3ffe526bed718240fc8b800e56e-p_d.jpg",
        "https://photos.zillowstatic.com/fp/785cfd0831dcf40cf24a2b00efcf8526-p_d.jpg",
        "https://photos.zillowstatic.com/fp/a960377a8725dab85120cd42a4e8c17e-p_d.jpg",
        "https://photos.zillowstatic.com/fp/8bb410fbccda8b61fafe2b188dbc384c-p_d.jpg",
        "https://photos.zillowstatic.com/fp/4cd9e12c5b5db5d755c88bfcd4c138a6-p_d.jpg",
        "https://photos.zillowstatic.com/fp/2ee0affccb8e26ef62b79164cd2578fa-p_d.jpg",
        "https://photos.zillowstatic.com/fp/a9d993778e8ec3dd735ba09aafc44a0b-p_d.jpg",
        "https://photos.zillowstatic.com/fp/d1d14a2f19619a7fa0ec89977d50d47f-p_d.jpg",
        "https://photos.zillowstatic.com/fp/1ba05f879b8af094bc275ee046dc44fe-p_d.jpg",
        "https://photos.zillowstatic.com/fp/3f3e692d290f5a4ed4cdba4bdf2b034c-p_d.jpg",
        "https://photos.zillowstatic.com/fp/700c7eafbe07aa87126540c874d7c1b0-p_d.jpg",
        "https://photos.zillowstatic.com/fp/e25ce63709ad1a2dd189480baea0c71b-p_d.jpg",
        "https://photos.zillowstatic.com/fp/e2c3e42bcc9071eefce4c1d3d3c8eb04-p_d.jpg",
        "https://photos.zillowstatic.com/fp/d69e735ac26febee4728aa0d3eaea811-p_d.jpg",
        "https://photos.zillowstatic.com/fp/7ab679173bcc5e9a1351d02ec8abeb5e-p_d.jpg",
        "https://photos.zillowstatic.com/fp/f370be1be521824163d0737e39a3f76f-p_d.jpg",
        "https://photos.zillowstatic.com/fp/53fffbe2d691189c36192ef52f8674ac-p_d.jpg",
        "https://photos.zillowstatic.com/fp/683bd06414806b263be5173d9dc50fe2-p_d.jpg"
      ],
      "homeStatus": "FOR_SALE",
      "price": 2950,
      "rating": 8.5,
      "type": "Villa",
      "address": {
        "streetAddress": "7709 Vicky Ave",
        "city": "Canoga Park",
        "state": "CA",
        "zipcode": "91304",
        "neighborhood": null,
        "community": null,
        "subdivision": null
      },
      "yearBuilt": 1965,
      "bedrooms": 5,
      "bathrooms": 3,
      "livingArea": 2284,
      "url": "https://www.zillow.com/homedetails/7709-Vicky-Ave-Canoga-Park-CA-91304/51578731_zpid/",
      "_id": "ntogoq6ba6o",
      "__index": 23
    },
    {
      "photos": [
        "https://photos.zillowstatic.com/fp/57df9c733afe7e9cb281f80e563f4273-p_d.jpg",
        "https://photos.zillowstatic.com/fp/e7f04bb5ba1c74424170ce62e5a663d1-p_d.jpg",
        "https://photos.zillowstatic.com/fp/34795f7de5bbe534861aaaa7c9932ae7-p_d.jpg",
        "https://photos.zillowstatic.com/fp/da6eb4be670eca88c1462bd267e48126-p_d.jpg",
        "https://photos.zillowstatic.com/fp/f6920083c80903bb96edadb040f73efc-p_d.jpg",
        "https://photos.zillowstatic.com/fp/7167018f6c069c9de46ec46bf170a64b-p_d.jpg",
        "https://photos.zillowstatic.com/fp/27ff8b641f6d01b7d155d3db472a9f58-p_d.jpg",
        "https://photos.zillowstatic.com/fp/6704f2a0c0e225b60bcdac718b9d234e-p_d.jpg",
        "https://photos.zillowstatic.com/fp/d239868d03fef34ff4a520bc2597b7ce-p_d.jpg",
        "https://photos.zillowstatic.com/fp/e96178608092e7326f5adbe62cdf3faa-p_d.jpg",
        "https://photos.zillowstatic.com/fp/0609674951227d6caa7940bc62cbd84c-p_d.jpg",
        "https://photos.zillowstatic.com/fp/cb53e6da0e58ffc3b27ead07d429a37c-p_d.jpg",
        "https://photos.zillowstatic.com/fp/d874da959d17da5206ebfb78482e7bd7-p_d.jpg",
        "https://photos.zillowstatic.com/fp/47acb31732d8c6e53f7265f1b1ab2b25-p_d.jpg",
        "https://photos.zillowstatic.com/fp/6191a8097438d99464e99e41c1172cca-p_d.jpg",
        "https://photos.zillowstatic.com/fp/753592560a263b576fe58c94bc254d81-p_d.jpg",
        "https://photos.zillowstatic.com/fp/61d22c39c220a017d6d5fb907a655f73-p_d.jpg",
        "https://photos.zillowstatic.com/fp/94433989fd64e4c2080bd5908ad7bbc8-p_d.jpg",
        "https://photos.zillowstatic.com/fp/7ca6eca35be84a3f1bfd3b55927513c3-p_d.jpg",
        "https://photos.zillowstatic.com/fp/1f25b4ab2d6c0288d6ac42545600c144-p_d.jpg",
        "https://photos.zillowstatic.com/fp/b782db93b98667555b3ad28de9b8cca8-p_d.jpg",
        "https://photos.zillowstatic.com/fp/8df759ab6fd977d4363524370df36ac6-p_d.jpg",
        "https://photos.zillowstatic.com/fp/ae77128da75b98dec8130d38aa2f885f-p_d.jpg",
        "https://photos.zillowstatic.com/fp/00f2db69cef38bbafddbf0c69d5b48eb-p_d.jpg"
      ],
      "homeStatus": "RECENTLY_SOLD",
      "price": 9000,
      "rating": 1,
      "type": "Villa",
      "address": {
        "streetAddress": "14335 Huston St APT 106",
        "city": "Sherman Oaks",
        "state": "CA",
        "zipcode": "91423",
        "neighborhood": null,
        "community": null,
        "subdivision": null
      },
      "yearBuilt": 1965,
      "bedrooms": 2,
      "bathrooms": 2,
      "livingArea": 1080,
      "url": "https://www.zillow.com/homedetails/14335-Huston-St-APT-106-Sherman-Oaks-CA-91423/19974913_zpid/",
      "_id": "skl2zrul5t",
      "__index": 24
    },
    {
      "photos": [
        "https://photos.zillowstatic.com/fp/caf13fd97ab2aaceb2da3a6b614d3dae-p_d.jpg",
        "https://photos.zillowstatic.com/fp/16a38ab80b55338c126ea6e5f08ebe19-p_d.jpg"
      ],
      "homeStatus": "FOR_SALE",
      "price": 8904,
      "rating": 7,
      "type": "Guest House",
      "address": {
        "streetAddress": "27635 Heartwood Dr",
        "city": "San Pedro",
        "state": "CA",
        "zipcode": "90732",
        "neighborhood": null,
        "community": null,
        "subdivision": "Skyview at Ponte Vista"
      },
      "yearBuilt": 2022,
      "bedrooms": 4,
      "bathrooms": 4,
      "livingArea": 2057,
      "url": "https://www.zillow.com/homedetails/27635-Heartwood-Dr-San-Pedro-CA-90732/2060666969_zpid/",
      "_id": "nv5sti4zu89",
      "__index": 25
    },
    {
      "photos": [
        "https://photos.zillowstatic.com/fp/41538228d4aef7d8f1ef6e9041b7e10c-p_d.jpg"
      ],
      "homeStatus": "RECENTLY_SOLD",
      "price": 1837,
      "rating": 3,
      "type": "House",
      "address": {
        "streetAddress": "16393 Royal Hills Dr",
        "city": "Encino",
        "state": "CA",
        "zipcode": "91436",
        "neighborhood": null,
        "community": null,
        "subdivision": null
      },
      "yearBuilt": 1958,
      "bedrooms": 3,
      "bathrooms": 2,
      "livingArea": 2091,
      "url": "https://www.zillow.com/homedetails/16393-Royal-Hills-Dr-Encino-CA-91436/19992684_zpid/",
      "_id": "1cnrm0mi8sf",
      "__index": 26
    },
    {
      "photos": [
        "https://photos.zillowstatic.com/fp/b446bcab0ec04fc0be5bc82117e5cf87-p_d.jpg",
        "https://photos.zillowstatic.com/fp/3142f551eb31000d05873917e8d2548d-p_d.jpg",
        "https://photos.zillowstatic.com/fp/dcefbbc2317201555227cacc07fb5cac-p_d.jpg",
        "https://photos.zillowstatic.com/fp/304f497ab197e24a037e3a1e694d7c08-p_d.jpg",
        "https://photos.zillowstatic.com/fp/c27fd877ec54cd6b2b96690c43492195-p_d.jpg",
        "https://photos.zillowstatic.com/fp/1424f1463f8e37d8c161f97acb3e2bd4-p_d.jpg",
        "https://photos.zillowstatic.com/fp/60bae6abfd16c411d1b53d5d928a0e5f-p_d.jpg",
        "https://photos.zillowstatic.com/fp/102af85cb955f6be017d082205286c65-p_d.jpg",
        "https://photos.zillowstatic.com/fp/42e6744ba7f8afc60de9fbd40ae75452-p_d.jpg",
        "https://photos.zillowstatic.com/fp/84933fcdafc83260bd3cf7ed319c615d-p_d.jpg",
        "https://photos.zillowstatic.com/fp/3007c059517ce9797b11ed2495515619-p_d.jpg",
        "https://photos.zillowstatic.com/fp/33542cc61d38fccac08392b3570c942a-p_d.jpg",
        "https://photos.zillowstatic.com/fp/6a37667f9c7e5b3380e001fb9e33d135-p_d.jpg",
        "https://photos.zillowstatic.com/fp/9e8cc8f92b6389702595fd6cb3108e85-p_d.jpg",
        "https://photos.zillowstatic.com/fp/f2b1b090d42ac86f4cf5a61e6f59bd84-p_d.jpg",
        "https://photos.zillowstatic.com/fp/caa89fedfd727479a781a76d1e5babef-p_d.jpg",
        "https://photos.zillowstatic.com/fp/4c4652861789efc8314f9b74d7890e75-p_d.jpg",
        "https://photos.zillowstatic.com/fp/dab46f08f4d567fd84b5252aebef3301-p_d.jpg",
        "https://photos.zillowstatic.com/fp/e4100a427a14e6020d77472c44481dcd-p_d.jpg",
        "https://photos.zillowstatic.com/fp/1a8f68b21e024921643faf71ab85b6fa-p_d.jpg",
        "https://photos.zillowstatic.com/fp/5e878d9e93dd0094f2091d9cca88ef91-p_d.jpg"
      ],
      "homeStatus": "FOR_SALE",
      "price": 899,
      "rating": 8,
      "type": "Condo",
      "address": {
        "streetAddress": "10925 Goss St",
        "city": "Sun Valley",
        "state": "CA",
        "zipcode": "91352",
        "neighborhood": null,
        "community": null,
        "subdivision": null
      },
      "yearBuilt": 1961,
      "bedrooms": 4,
      "bathrooms": 3,
      "livingArea": 1709,
      "url": "https://www.zillow.com/homedetails/10925-Goss-St-Sun-Valley-CA-91352/20037012_zpid/",
      "_id": "0987m5pts5xc",
      "__index": 27
    },
    {
      "photos": [
        "https://photos.zillowstatic.com/fp/27e77ca2d7c1608415e6a46a5c1d6f7b-p_d.jpg",
        "https://photos.zillowstatic.com/fp/eb3af2c320dea83c1c2c0d958ce23edf-p_d.jpg",
        "https://photos.zillowstatic.com/fp/4eb6d06a559bd2397b95cdd128f5cdf8-p_d.jpg",
        "https://photos.zillowstatic.com/fp/0994fb9114fcccbdbcefb3b2341542d5-p_d.jpg",
        "https://photos.zillowstatic.com/fp/6d9aa01dfe99afd626365b7f321a9ab8-p_d.jpg",
        "https://photos.zillowstatic.com/fp/4a741a247850368a95012bb48b046ffa-p_d.jpg",
        "https://photos.zillowstatic.com/fp/3632603f19aa4330474aaee3955a8f41-p_d.jpg",
        "https://photos.zillowstatic.com/fp/6c8b3fae5c4f8e398253c2331f554bfe-p_d.jpg",
        "https://photos.zillowstatic.com/fp/f13e51901a443db47a721c4f89b85c45-p_d.jpg",
        "https://photos.zillowstatic.com/fp/decb617cb06ed9e4b9508db0a367b1fd-p_d.jpg",
        "https://photos.zillowstatic.com/fp/22a2a25e5fb571663bcf9d07d8ca7358-p_d.jpg",
        "https://photos.zillowstatic.com/fp/1569bfe0294b0f809021202003fc3640-p_d.jpg",
        "https://photos.zillowstatic.com/fp/765a83f2b0856c429190062ccb1248e9-p_d.jpg",
        "https://photos.zillowstatic.com/fp/f1d3fea9edf9be1908fb999a57e8c6aa-p_d.jpg",
        "https://photos.zillowstatic.com/fp/06cd1243f6f08eff09300ad61a40a054-p_d.jpg",
        "https://photos.zillowstatic.com/fp/8672e3a7cd7a7795f8bdc251dca0aa27-p_d.jpg",
        "https://photos.zillowstatic.com/fp/853c67f6ce85afe48607d414842a1187-p_d.jpg",
        "https://photos.zillowstatic.com/fp/a8e685bcac69fbce7ce3079550ec5ca8-p_d.jpg",
        "https://photos.zillowstatic.com/fp/695f0180d241ad30c79e904f246b8098-p_d.jpg",
        "https://photos.zillowstatic.com/fp/c9c0d592166811186de14034d8890403-p_d.jpg",
        "https://photos.zillowstatic.com/fp/210d99e2863ad01017cf1eb2fcb2cc3f-p_d.jpg",
        "https://photos.zillowstatic.com/fp/71684042412a0ec473a1b388257588db-p_d.jpg",
        "https://photos.zillowstatic.com/fp/d71865866667f7f7b9537fd4d8775dc0-p_d.jpg"
      ],
      "homeStatus": "FOR_SALE",
      "price": 2299,
      "rating": 10,
      "type": "House",
      "address": {
        "streetAddress": "8314 N Mariposa Ct",
        "city": "Canoga Park",
        "state": "CA",
        "zipcode": "91304",
        "neighborhood": null,
        "community": null,
        "subdivision": "Sterling at West Hills"
      },
      "yearBuilt": 2022,
      "bedrooms": 5,
      "bathrooms": 6,
      "livingArea": 4336,
      "url": "https://www.zillow.com/homedetails/8314-N-Mariposa-Ct-Canoga-Park-CA-91304/2065507132_zpid/",
      "_id": "nwr03y2kgt",
      "__index": 28
    },
    {
      "photos": [
        "https://photos.zillowstatic.com/fp/3137549772a2a68eb5afe957131f56ed-p_d.jpg"
      ],
      "homeStatus": "RECENTLY_SOLD",
      "price": 7709,
      "rating": 5,
      "type": "Apartment",
      "address": {
        "streetAddress": "5252 Bluebell Ave",
        "city": "Valley Village",
        "state": "CA",
        "zipcode": "91607",
        "neighborhood": null,
        "community": null,
        "subdivision": null
      },
      "yearBuilt": 2019,
      "bedrooms": 4,
      "bathrooms": 6,
      "livingArea": 3056,
      "url": "https://www.zillow.com/homedetails/5252-Bluebell-Ave-Valley-Village-CA-91607/20016601_zpid/",
      "_id": "zemj0oytct",
      "__index": 29
    },
    {
      "photos": [
        "https://photos.zillowstatic.com/fp/f8c85f4a7caf97812e54d073997e820f-p_d.jpg",
        "https://photos.zillowstatic.com/fp/16a38ab80b55338c126ea6e5f08ebe19-p_d.jpg"
      ],
      "homeStatus": "FOR_SALE",
      "price": 3350,
      "rating": 4.5,
      "type": "Condo",
      "address": {
        "streetAddress": "27658 Heartwood Dr",
        "city": "San Pedro",
        "state": "CA",
        "zipcode": "90732",
        "neighborhood": null,
        "community": null,
        "subdivision": "Skyview at Ponte Vista"
      },
      "yearBuilt": 2022,
      "bedrooms": 4,
      "bathrooms": 4,
      "livingArea": 2057,
      "url": "https://www.zillow.com/homedetails/27658-Heartwood-Dr-San-Pedro-CA-90732/2060684836_zpid/",
      "_id": "78ct1o8f323",
      "__index": 30
    },
    {
      "photos": [
        "https://photos.zillowstatic.com/fp/7bbcfe99a1371a8ff7cce510b24e6009-p_d.jpg",
        "https://photos.zillowstatic.com/fp/d22a911706b3083203a8491e1f1a6912-p_d.jpg",
        "https://photos.zillowstatic.com/fp/0d31f7f1614f6dfd79236206ae09adf9-p_d.jpg",
        "https://photos.zillowstatic.com/fp/f3696f2341a22fa31eddc543ca1a2d85-p_d.jpg",
        "https://photos.zillowstatic.com/fp/0b24ad0c2eb63de42c818ca535c4a1f5-p_d.jpg",
        "https://photos.zillowstatic.com/fp/9d824d6b4ba9af3d93c88f3b8b5dc4cb-p_d.jpg",
        "https://photos.zillowstatic.com/fp/00163e2511e0a44be5ed6b623d73d7bd-p_d.jpg",
        "https://photos.zillowstatic.com/fp/2b6397205b76e5eb49f6c237537caf45-p_d.jpg",
        "https://photos.zillowstatic.com/fp/8a6f4d5acada1c198512a4b3bb2916c7-p_d.jpg",
        "https://photos.zillowstatic.com/fp/5bcec5cde5dea708e9011d4294072761-p_d.jpg",
        "https://photos.zillowstatic.com/fp/40cd07fa05e68192e2c0deaaeefd0f94-p_d.jpg",
        "https://photos.zillowstatic.com/fp/3f21691dae18efd18756f05f97a96134-p_d.jpg",
        "https://photos.zillowstatic.com/fp/f6940fe89428ed3952687cea1e9e6eba-p_d.jpg",
        "https://photos.zillowstatic.com/fp/2beb9199d9b4b451675972df8f96ab67-p_d.jpg",
        "https://photos.zillowstatic.com/fp/f6cb1a4a062685bbdc10a8a96c6262c6-p_d.jpg",
        "https://photos.zillowstatic.com/fp/e388ff8faf231567d3081cb8033d0339-p_d.jpg",
        "https://photos.zillowstatic.com/fp/139f8b73c84d90b41adc948f1f2cc6b3-p_d.jpg",
        "https://photos.zillowstatic.com/fp/c815698eef2c57c9ea75288d58a39d98-p_d.jpg",
        "https://photos.zillowstatic.com/fp/1d555df058ae6f57e9c11e159f0fd7a8-p_d.jpg",
        "https://photos.zillowstatic.com/fp/d9afde9e792b7e91111ea49a4995cf19-p_d.jpg",
        "https://photos.zillowstatic.com/fp/1d534c7a949ae478ccd8bf4590ca8ca7-p_d.jpg",
        "https://photos.zillowstatic.com/fp/17c2826f7636bc67748dfaa0ce284663-p_d.jpg"
      ],
      "homeStatus": "FOR_SALE",
      "price": 6990,
      "rating": 7,
      "type": "Guest House",
      "address": {
        "streetAddress": "8922 Chimineas Ave",
        "city": "Northridge",
        "state": "CA",
        "zipcode": "91325",
        "neighborhood": null,
        "community": null,
        "subdivision": null
      },
      "yearBuilt": 1949,
      "bedrooms": 2,
      "bathrooms": 2,
      "livingArea": 1256,
      "url": "https://www.zillow.com/homedetails/8922-Chimineas-Ave-Northridge-CA-91325/20177872_zpid/",
      "_id": "aqflrj0bnce",
      "__index": 31
    },
    {
      "photos": [
        "https://photos.zillowstatic.com/fp/0f60ed13ee129b3e8f75642ce1643079-p_d.jpg",
        "https://photos.zillowstatic.com/fp/c728fcec93f5fd0de33af5f59dde52c0-p_d.jpg",
        "https://photos.zillowstatic.com/fp/93ca68dc58350f0eec7ec6e24b7d1e33-p_d.jpg",
        "https://photos.zillowstatic.com/fp/10d2a6bfa51fcde514d7f859ca9f0929-p_d.jpg",
        "https://photos.zillowstatic.com/fp/e711b4bda0943c55bc968958904b6be0-p_d.jpg",
        "https://photos.zillowstatic.com/fp/842649850f1799eeb194ec8ddae1f2b0-p_d.jpg",
        "https://photos.zillowstatic.com/fp/3ab13d422267d90c1ad1a72c49e075c2-p_d.jpg",
        "https://photos.zillowstatic.com/fp/744334248d7afdd6721aac588441e460-p_d.jpg",
        "https://photos.zillowstatic.com/fp/e852d9478dfc3eb9d4896baa8fbefd96-p_d.jpg",
        "https://photos.zillowstatic.com/fp/a27b27557b2c524555b201f6c3b0e7fb-p_d.jpg",
        "https://photos.zillowstatic.com/fp/c70b906c46c72cf57774e24911bad802-p_d.jpg",
        "https://photos.zillowstatic.com/fp/cdbb63cecfa8242a49311ff915bb0309-p_d.jpg",
        "https://photos.zillowstatic.com/fp/847f013cf3a68ff25816f205b873ac70-p_d.jpg",
        "https://photos.zillowstatic.com/fp/7dea35ce6f7d6754810657863ba54890-p_d.jpg",
        "https://photos.zillowstatic.com/fp/494054dc5fee14dd5e8e86c39bcdc94c-p_d.jpg",
        "https://photos.zillowstatic.com/fp/d2723e186cfb41468f23061af971ddbf-p_d.jpg",
        "https://photos.zillowstatic.com/fp/6e0a3ec06bd58af61810d4acfa430239-p_d.jpg",
        "https://photos.zillowstatic.com/fp/e5c1d007599085c3bb1e9e1d1590f5f2-p_d.jpg",
        "https://photos.zillowstatic.com/fp/3342b709fcc3a2a07faf050b375db1e7-p_d.jpg",
        "https://photos.zillowstatic.com/fp/64c289df17bfef01d432f8d84854d40d-p_d.jpg",
        "https://photos.zillowstatic.com/fp/220286d4cf512502196664827d0acc91-p_d.jpg",
        "https://photos.zillowstatic.com/fp/c4e879794fa1fda93f6a4e230caae1e0-p_d.jpg",
        "https://photos.zillowstatic.com/fp/01ed4a4244054708af1485457e326d5f-p_d.jpg",
        "https://photos.zillowstatic.com/fp/68bf9740d518a1bce71a203087bf8d90-p_d.jpg",
        "https://photos.zillowstatic.com/fp/d1f1d0a47e1b795934e0728b9860c33f-p_d.jpg",
        "https://photos.zillowstatic.com/fp/f54f70a7ce80ae6cebe72698e4ccabba-p_d.jpg",
        "https://photos.zillowstatic.com/fp/ac31a52904b49da9cd997f088cc56e55-p_d.jpg"
      ],
      "homeStatus": "FOR_SALE",
      "price": 9999,
      "rating": 8,
      "type": "Condo",
      "address": {
        "streetAddress": "22119 Burbank Blvd UNIT 6",
        "city": "Woodland Hills",
        "state": "CA",
        "zipcode": "91367",
        "neighborhood": null,
        "community": null,
        "subdivision": null
      },
      "yearBuilt": 1977,
      "bedrooms": 2,
      "bathrooms": 1.5,
      "livingArea": 961,
      "url": "https://www.zillow.com/homedetails/22119-Burbank-Blvd-UNIT-6-Woodland-Hills-CA-91367/19928944_zpid/",
      "_id": "c7s7odgtmqf",
      "__index": 32
    },
    {
      "photos": [
        "https://photos.zillowstatic.com/fp/17e93954f9c854df742be4622b06059d-p_d.jpg",
        "https://photos.zillowstatic.com/fp/3fcdf8f5180de3d699800d62a8e2d84b-p_d.jpg",
        "https://photos.zillowstatic.com/fp/b0481dd7592e1a83807c79d6cde03882-p_d.jpg",
        "https://photos.zillowstatic.com/fp/d8683f44d0c71fac5b78d69d8197439b-p_d.jpg",
        "https://photos.zillowstatic.com/fp/ac53252bb91fe8e43adecb302c7f9f61-p_d.jpg",
        "https://photos.zillowstatic.com/fp/90bfc6c994e730fe92c56509befc7ad8-p_d.jpg",
        "https://photos.zillowstatic.com/fp/60777ba29427524fc0fd3b7ab679abd8-p_d.jpg",
        "https://photos.zillowstatic.com/fp/9a1dd40931f7b229ffa82757ffb4641e-p_d.jpg",
        "https://photos.zillowstatic.com/fp/8d4d0b7720d5873fb182179943df32a6-p_d.jpg",
        "https://photos.zillowstatic.com/fp/3af25282fbdf05499534935e4fd8fde6-p_d.jpg",
        "https://photos.zillowstatic.com/fp/6d4c794722fa5867a9b3145334729c87-p_d.jpg",
        "https://photos.zillowstatic.com/fp/3e164da0872ec3410f3446a4e961164b-p_d.jpg",
        "https://photos.zillowstatic.com/fp/609bd8ef483ca07d9b1c1d5b83107fde-p_d.jpg",
        "https://photos.zillowstatic.com/fp/5ffb672c5b277233bfb6786446aa043e-p_d.jpg",
        "https://photos.zillowstatic.com/fp/ff6665667963c6b7649e0582fa67b3eb-p_d.jpg",
        "https://photos.zillowstatic.com/fp/38e332484f25e616294468aa9ea3dff6-p_d.jpg",
        "https://photos.zillowstatic.com/fp/03e726d13f9942546e124f35c8269aa2-p_d.jpg",
        "https://photos.zillowstatic.com/fp/8b89bd2e9c03b8ee0286d8dc950f245c-p_d.jpg",
        "https://photos.zillowstatic.com/fp/c0408cc1cc3fdb6a06382967a561284d-p_d.jpg",
        "https://photos.zillowstatic.com/fp/e449234b8600690643b7425946eeb9f3-p_d.jpg",
        "https://photos.zillowstatic.com/fp/fa5b86e6e01dc2edfb9b9888e07f51cc-p_d.jpg",
        "https://photos.zillowstatic.com/fp/a05c7d66be02b6e63c0598cda6258736-p_d.jpg",
        "https://photos.zillowstatic.com/fp/92698bd2db1d7f1efecb1b7184ca9912-p_d.jpg",
        "https://photos.zillowstatic.com/fp/db4e43fa832fded0668040195a44151c-p_d.jpg",
        "https://photos.zillowstatic.com/fp/c56a33a172ff22b8364d44c771e283e2-p_d.jpg",
        "https://photos.zillowstatic.com/fp/fa2a92c9e2a35b267e29fa12755906e8-p_d.jpg",
        "https://photos.zillowstatic.com/fp/55aa1b51a763497604b03e536f469b4f-p_d.jpg",
        "https://photos.zillowstatic.com/fp/10b6877965509d30dbbba39a8880bf6d-p_d.jpg",
        "https://photos.zillowstatic.com/fp/94e6c8e29fa2e121be3b7b2733413eb7-p_d.jpg",
        "https://photos.zillowstatic.com/fp/11ae11fdedbd10ccb22f2f2d564ec237-p_d.jpg",
        "https://photos.zillowstatic.com/fp/c45b5140bc1133da39e76e716670b98a-p_d.jpg",
        "https://photos.zillowstatic.com/fp/aa347da8d22a0ef283ff91b8a56389bb-p_d.jpg",
        "https://photos.zillowstatic.com/fp/ccec2c2a6363d5d0629fbe7dee6d38d2-p_d.jpg",
        "https://photos.zillowstatic.com/fp/3bd5e25d50231c8c157197eca68f6a39-p_d.jpg",
        "https://photos.zillowstatic.com/fp/a42c7217f09fa441cbc1452569ab3687-p_d.jpg",
        "https://photos.zillowstatic.com/fp/f3f960f44c95dec073ac6d0d48660eba-p_d.jpg",
        "https://photos.zillowstatic.com/fp/6ea108a28a79dcb13b3cf0a50473dbb6-p_d.jpg",
        "https://photos.zillowstatic.com/fp/7d19150858c9cded6ec1ddca91cb88c9-p_d.jpg",
        "https://photos.zillowstatic.com/fp/da2d9e74ff143afe3f254c0ecd99a17f-p_d.jpg",
        "https://photos.zillowstatic.com/fp/986ef3311f6673acaee167a4ee016b5a-p_d.jpg",
        "https://photos.zillowstatic.com/fp/85769d65ddb899ea1d8b8e8d2399dfaa-p_d.jpg",
        "https://photos.zillowstatic.com/fp/568444ef5a72e15c8956a13a679dc61c-p_d.jpg",
        "https://photos.zillowstatic.com/fp/e25e5421cb91809fd8a38e2803ed0646-p_d.jpg",
        "https://photos.zillowstatic.com/fp/33aa8281491e283c00fee500c298237d-p_d.jpg",
        "https://photos.zillowstatic.com/fp/1d20d0ffe237ebb1bff2107c356dd09f-p_d.jpg",
        "https://photos.zillowstatic.com/fp/ce6a3d98c3ec2abadde3b5e001338f1a-p_d.jpg",
        "https://photos.zillowstatic.com/fp/acadbee1df1c72c3ea799c92c6780c9e-p_d.jpg",
        "https://photos.zillowstatic.com/fp/4f43adfa6887c0fb19382d2713b9f1f4-p_d.jpg",
        "https://photos.zillowstatic.com/fp/ac32ffb87b63a4e25f7181212b0b66ed-p_d.jpg",
        "https://photos.zillowstatic.com/fp/87b51ab5d07b85096c3c4f1f30d46eb1-p_d.jpg",
        "https://photos.zillowstatic.com/fp/b6db6d005f960ac6c3425d41b975e505-p_d.jpg",
        "https://photos.zillowstatic.com/fp/9b36c2590e119ff4782ca4f075b4e509-p_d.jpg",
        "https://photos.zillowstatic.com/fp/49772efe88c2484abfadddc4f583a057-p_d.jpg",
        "https://photos.zillowstatic.com/fp/e538b1146136c28acab550a24cc005f1-p_d.jpg",
        "https://photos.zillowstatic.com/fp/5eb288e0781e77b0307a8d9b6af0d7fa-p_d.jpg",
        "https://photos.zillowstatic.com/fp/3d0a8fc8d1effb113379c73f1d1df048-p_d.jpg",
        "https://photos.zillowstatic.com/fp/f22938230d2fef66eb62de7c4ef7774e-p_d.jpg",
        "https://photos.zillowstatic.com/fp/cb300078aff0602849b7c59272f9f25c-p_d.jpg",
        "https://photos.zillowstatic.com/fp/a44738c23c8abfc59dcbeaecea3b8a19-p_d.jpg",
        "https://photos.zillowstatic.com/fp/adead118dfd2e63d8b20e5f0b7e3ee62-p_d.jpg",
        "https://photos.zillowstatic.com/fp/bce507427c0683c00b7de30ebc4c2042-p_d.jpg",
        "https://photos.zillowstatic.com/fp/c096579a3274eabdf865f3b82463ce8f-p_d.jpg",
        "https://photos.zillowstatic.com/fp/bdafd1997099fb8859fc8982e3e94e8c-p_d.jpg",
        "https://photos.zillowstatic.com/fp/363f462b9c213d894d3e8f0ec9531293-p_d.jpg",
        "https://photos.zillowstatic.com/fp/67cc95b109bbefc0c37f44189d4ab64a-p_d.jpg",
        "https://photos.zillowstatic.com/fp/2809804a979718778df6b934f2de4ddf-p_d.jpg"
      ],
      "homeStatus": "RECENTLY_SOLD",
      "price": 4490,
      "rating": 2.4,
      "type": "Villa",
      "address": {
        "streetAddress": "11725 Hesby St",
        "city": "Valley Village",
        "state": "CA",
        "zipcode": "91607",
        "neighborhood": null,
        "community": null,
        "subdivision": null
      },
      "yearBuilt": 2022,
      "bedrooms": 5,
      "bathrooms": 7,
      "livingArea": 4400,
      "url": "https://www.zillow.com/homedetails/11725-Hesby-St-Valley-Village-CA-91607/20019486_zpid/",
      "_id": "cksqsog6nnw",
      "__index": 33
    },
    {
      "photos": [
        "https://photos.zillowstatic.com/fp/db793042f7efe9e0b0601f8a9aabf696-p_d.jpg",
        "https://photos.zillowstatic.com/fp/0b81403717c9ff923cc059dc6fb5c2d6-p_d.jpg",
        "https://photos.zillowstatic.com/fp/19578b7a25b4dbcf15e7a1e72f49cc5a-p_d.jpg",
        "https://photos.zillowstatic.com/fp/b8222a24a7bc609cff1e2f9a551c6032-p_d.jpg",
        "https://photos.zillowstatic.com/fp/1d67fbe2ee3ce54aedb4f081551e49b6-p_d.jpg",
        "https://photos.zillowstatic.com/fp/2fa462e8090399d27768854e6039b52a-p_d.jpg",
        "https://photos.zillowstatic.com/fp/0f4d8c546dc9fe7e9c3689964bf5c02c-p_d.jpg",
        "https://photos.zillowstatic.com/fp/6ddb42ef78e5b3bed1c46ce0e66b8300-p_d.jpg",
        "https://photos.zillowstatic.com/fp/15c9e834f62f307979e8e4a1ce2044fb-p_d.jpg",
        "https://photos.zillowstatic.com/fp/600e72f21e2083400750db11a322a340-p_d.jpg",
        "https://photos.zillowstatic.com/fp/fff34f7c5b63155278d29827e30603a3-p_d.jpg",
        "https://photos.zillowstatic.com/fp/aba887ec081bea81b503032fb927a693-p_d.jpg",
        "https://photos.zillowstatic.com/fp/ecbc7170506c6528551226eb90978f05-p_d.jpg",
        "https://photos.zillowstatic.com/fp/65ac4d07cbe2b61db36507514aaaba41-p_d.jpg",
        "https://photos.zillowstatic.com/fp/d9ad4b923cabff6fd5f5704a5d2211e6-p_d.jpg",
        "https://photos.zillowstatic.com/fp/637087fe337c51addee50abf71c16e33-p_d.jpg",
        "https://photos.zillowstatic.com/fp/5e88ab7a752aa8e2a152e5d49366822b-p_d.jpg",
        "https://photos.zillowstatic.com/fp/1ec375cc04e00b0eebf091ad28b25e2c-p_d.jpg",
        "https://photos.zillowstatic.com/fp/335cfa42341a3689adccb4b68d30b306-p_d.jpg",
        "https://photos.zillowstatic.com/fp/b48b05b0ce2c2cdf87b76b12d7193185-p_d.jpg",
        "https://photos.zillowstatic.com/fp/d2a183a57564056a21c4cbae16462d90-p_d.jpg",
        "https://photos.zillowstatic.com/fp/0932c8f2f32bd1f197140fe74ad503bc-p_d.jpg",
        "https://photos.zillowstatic.com/fp/ce33e92d1bf9c4dfff27168d92b228b4-p_d.jpg",
        "https://photos.zillowstatic.com/fp/2925cbd1380057b2583be1ae04c2f8df-p_d.jpg",
        "https://photos.zillowstatic.com/fp/78ae2766599c86b4330cd7aac28ea0c9-p_d.jpg",
        "https://photos.zillowstatic.com/fp/f5500030eb1d508ff0de75ef9d455820-p_d.jpg",
        "https://photos.zillowstatic.com/fp/dba83f4064e0e1a9da42957136f1470c-p_d.jpg",
        "https://photos.zillowstatic.com/fp/6cf6540bf1f756f4909f94751dbd368b-p_d.jpg",
        "https://photos.zillowstatic.com/fp/2a5f1e0ae773750410190bf578330a29-p_d.jpg",
        "https://photos.zillowstatic.com/fp/c7fdeb471199a44834a4d1f361312302-p_d.jpg",
        "https://photos.zillowstatic.com/fp/b47a1635872a0e4eb7e6d433285b9463-p_d.jpg",
        "https://photos.zillowstatic.com/fp/4f8371787eb7f41f26ea0c4f1d151157-p_d.jpg",
        "https://photos.zillowstatic.com/fp/8a00010adc0794aaa7155e6b8aba06ac-p_d.jpg",
        "https://photos.zillowstatic.com/fp/8b3afc04bb2b140c4d3d0e755eb06c6d-p_d.jpg",
        "https://photos.zillowstatic.com/fp/836a269c389da7c13d3860769d546793-p_d.jpg",
        "https://photos.zillowstatic.com/fp/bd953a33de34f3a74cbc9a3075be9815-p_d.jpg",
        "https://photos.zillowstatic.com/fp/4bee951ac8d216db18ec9fa671d2855e-p_d.jpg",
        "https://photos.zillowstatic.com/fp/51dd5804d6657ae379d94117ab25ac33-p_d.jpg",
        "https://photos.zillowstatic.com/fp/204777d8e8f363bffa13758cbd19b8cb-p_d.jpg",
        "https://photos.zillowstatic.com/fp/fb1d9c57e9ef3d7d94e502951456a9d2-p_d.jpg",
        "https://photos.zillowstatic.com/fp/6e0dc8d8e0a18e51a94698c68abee6e7-p_d.jpg",
        "https://photos.zillowstatic.com/fp/74134dc487784cf9f177cf379a875885-p_d.jpg",
        "https://photos.zillowstatic.com/fp/2d31050df3517bf377f23ab849754e37-p_d.jpg",
        "https://photos.zillowstatic.com/fp/3aeda669370054594ec3bdf09f99e9a7-p_d.jpg",
        "https://photos.zillowstatic.com/fp/224fc0a64d2c7f3d18ed19efd281a1ea-p_d.jpg",
        "https://photos.zillowstatic.com/fp/aaa725b4a42b6125e2ace8f71ceb2568-p_d.jpg",
        "https://photos.zillowstatic.com/fp/6f2f294bf3b1e1c2be395752978c4709-p_d.jpg",
        "https://photos.zillowstatic.com/fp/af48f51a52b6d285b6df9a8fe1404709-p_d.jpg",
        "https://photos.zillowstatic.com/fp/3ffaf77792b3db4a10de846b5fa0bf89-p_d.jpg",
        "https://photos.zillowstatic.com/fp/cd88377f990e985ebf3b92e971ef42d7-p_d.jpg",
        "https://photos.zillowstatic.com/fp/2c8c1fc25e4d32869f2ff19137afe1a4-p_d.jpg",
        "https://photos.zillowstatic.com/fp/41ad74f77aa1c7a059e27789c3fb81c1-p_d.jpg",
        "https://photos.zillowstatic.com/fp/7ae107d2490e927f6ff2aa09cb96b4f5-p_d.jpg",
        "https://photos.zillowstatic.com/fp/78a5cfec39ef071ada91e238ab1fbaa4-p_d.jpg",
        "https://photos.zillowstatic.com/fp/8291bfd8f0751e6f2be84d31f2419c22-p_d.jpg",
        "https://photos.zillowstatic.com/fp/700149ee69873ea3dbc104e55d3d9d34-p_d.jpg",
        "https://photos.zillowstatic.com/fp/c4d2c5d6e01b90c47777a11dfdd84010-p_d.jpg",
        "https://photos.zillowstatic.com/fp/bfc55bb7e8ce485443d2b79ae63daa09-p_d.jpg",
        "https://photos.zillowstatic.com/fp/eb8b46291b14588bab9be08380083a27-p_d.jpg",
        "https://photos.zillowstatic.com/fp/94f9a11b4b3364bd0a2171eb421c2ae1-p_d.jpg",
        "https://photos.zillowstatic.com/fp/f3fb297db854d800396da471776d4d48-p_d.jpg",
        "https://photos.zillowstatic.com/fp/91bb844278658e230471b4767cd99a1c-p_d.jpg",
        "https://photos.zillowstatic.com/fp/0e850c0e1730d816b42ee8ca968c4575-p_d.jpg",
        "https://photos.zillowstatic.com/fp/acf9ef3b4ee3efd3a5be07b9742110c9-p_d.jpg",
        "https://photos.zillowstatic.com/fp/8fb8157522f11c22e08a65f7f6910194-p_d.jpg",
        "https://photos.zillowstatic.com/fp/ade9c51da22da7e3dd81dfaea18ecc3a-p_d.jpg",
        "https://photos.zillowstatic.com/fp/ea54ef123ea3fc37e713481b8be82a53-p_d.jpg",
        "https://photos.zillowstatic.com/fp/8b0a15230db246271b89cc30d37cfb32-p_d.jpg",
        "https://photos.zillowstatic.com/fp/e5c1cdbbc08f4eef8bfa0e053d8dd2d5-p_d.jpg",
        "https://photos.zillowstatic.com/fp/f6a8bbce6a0c3b70cbc8cadbfe82c166-p_d.jpg",
        "https://photos.zillowstatic.com/fp/8188473987f57d321e80c967b6e136b7-p_d.jpg"
      ],
      "homeStatus": "FOR_SALE",
      "price": 2195,
      "raing": 7.6,
      "type": "Apartment",
      "address": {
        "streetAddress": "5217 Dahlia Dr",
        "city": "Los Angeles",
        "state": "CA",
        "zipcode": "90041",
        "neighborhood": null,
        "community": null,
        "subdivision": null
      },
      "yearBuilt": 1933,
      "bedrooms": 4,
      "bathrooms": 3,
      "livingArea": 2369,
      "url": "https://www.zillow.com/homedetails/5217-Dahlia-Dr-Los-Angeles-CA-90041/20845073_zpid/",
      "_id": "uswjvjxhku",
      "__index": 34
    },
    {
      "photos": [
        "https://photos.zillowstatic.com/fp/3f450011ef13057771de68866f9506d8-p_d.jpg",
        "https://photos.zillowstatic.com/fp/ee1a31b3ffacd55cdb407970837f2a63-p_d.jpg",
        "https://photos.zillowstatic.com/fp/7efc7fd33138423c3c1ce39fc65a2889-p_d.jpg",
        "https://photos.zillowstatic.com/fp/354a0f013d73f26c66657c57f582ecaa-p_d.jpg",
        "https://photos.zillowstatic.com/fp/f712da3a022e86c9893bb8abb3406f8a-p_d.jpg",
        "https://photos.zillowstatic.com/fp/86c566592858f764114821d63e4bc536-p_d.jpg"
      ],
      "homeStatus": "FOR_SALE",
      "price": 5800,
      "rating": 4.9,
      "type": "House",
      "address": {
        "streetAddress": "525 N Sycamore Ave APT 405",
        "city": "Los Angeles",
        "state": "CA",
        "zipcode": "90036",
        "neighborhood": null,
        "community": null,
        "subdivision": null
      },
      "yearBuilt": 1972,
      "bedrooms": 1,
      "bathrooms": 1,
      "livingArea": 680,
      "url": "https://www.zillow.com/homedetails/525-N-Sycamore-Ave-APT-405-Los-Angeles-CA-90036/20784542_zpid/",
      "_id": "c53x3lvh57",
      "__index": 35
    },
    {
      "photos": [
        "https://photos.zillowstatic.com/fp/50c43f641762d6b1fc69b4333eb1b8cf-p_d.jpg",
        "https://photos.zillowstatic.com/fp/22735ac7c905133fc25b6ab3ae17c166-p_d.jpg",
        "https://photos.zillowstatic.com/fp/62c3f0fde93a47c08ac8fed784382004-p_d.jpg",
        "https://photos.zillowstatic.com/fp/3174fc1d42336f10efc04c6085afb904-p_d.jpg",
        "https://photos.zillowstatic.com/fp/46dc5ba75de1e7b9ef77fd940bb03e19-p_d.jpg",
        "https://photos.zillowstatic.com/fp/547c873927cbf688f3668d484c518f95-p_d.jpg",
        "https://photos.zillowstatic.com/fp/59ed5b5401f749ad18b615e35573d2be-p_d.jpg",
        "https://photos.zillowstatic.com/fp/af6783c430365c047bc11fc975ed414f-p_d.jpg",
        "https://photos.zillowstatic.com/fp/4705e06f63992eea5156355db08d1eef-p_d.jpg",
        "https://photos.zillowstatic.com/fp/7774444cdebccca6d49b569450dce4f9-p_d.jpg",
        "https://photos.zillowstatic.com/fp/2a05448d610c192e9f4fe53b12d05024-p_d.jpg",
        "https://photos.zillowstatic.com/fp/d9fee53e9675e45287939fb0a001c499-p_d.jpg",
        "https://photos.zillowstatic.com/fp/9e180209a2508c42ec0adf0c2fb8338b-p_d.jpg",
        "https://photos.zillowstatic.com/fp/ba3e43dc083a7825d38742eb1ba3fdb9-p_d.jpg",
        "https://photos.zillowstatic.com/fp/031257cbdd9eedbea0510216f78fbd0e-p_d.jpg",
        "https://photos.zillowstatic.com/fp/47d18cb9c634e10d2e86e94dbe748716-p_d.jpg",
        "https://photos.zillowstatic.com/fp/391b5948e248253a1f19e7b2649f7f86-p_d.jpg",
        "https://photos.zillowstatic.com/fp/5ec59e428db24d4fb4b8fbb5b954f291-p_d.jpg",
        "https://photos.zillowstatic.com/fp/503aa79ef1a6f538d12efacf7d6497f9-p_d.jpg",
        "https://photos.zillowstatic.com/fp/4884bc8eca060be2121402d23864b4be-p_d.jpg",
        "https://photos.zillowstatic.com/fp/e15a7cf567374870d7e4eca703e61c6e-p_d.jpg",
        "https://photos.zillowstatic.com/fp/13083961c75c97b52a1a4d2725679b9c-p_d.jpg",
        "https://photos.zillowstatic.com/fp/d2e65b4398bfe15e5ee9eb635f73ca99-p_d.jpg",
        "https://photos.zillowstatic.com/fp/7a36b101ac90179fb32601527c451de1-p_d.jpg",
        "https://photos.zillowstatic.com/fp/9575f4087b50aa5df5443bdf816d2350-p_d.jpg",
        "https://photos.zillowstatic.com/fp/3aaa2b60a73afd93aa8f5a546d34560a-p_d.jpg",
        "https://photos.zillowstatic.com/fp/be43872e2dd989d10937d0eeb67a179d-p_d.jpg",
        "https://photos.zillowstatic.com/fp/3c73e1169fbeedcd8589c67bd84e4a60-p_d.jpg",
        "https://photos.zillowstatic.com/fp/aeb66e7ecfa6587b39caa26deec6628e-p_d.jpg",
        "https://photos.zillowstatic.com/fp/a584b563f9e15e27b8e10b0439fb771c-p_d.jpg",
        "https://photos.zillowstatic.com/fp/1051d7daffd273cc40d58e9542b767d5-p_d.jpg",
        "https://photos.zillowstatic.com/fp/28b5923787fbbd3ad08b254ffc95a435-p_d.jpg",
        "https://photos.zillowstatic.com/fp/92400f8eb1f19ee695f0f283d909f0f8-p_d.jpg",
        "https://photos.zillowstatic.com/fp/64bb21987768a52984bae28c6321e94e-p_d.jpg",
        "https://photos.zillowstatic.com/fp/c451d9ac713a3fe6dc6192257d9c7d7e-p_d.jpg",
        "https://photos.zillowstatic.com/fp/b10eebf26b534939482cbc3b6767025c-p_d.jpg",
        "https://photos.zillowstatic.com/fp/3fe5588c1febb7f3dde1e0626db0398a-p_d.jpg",
        "https://photos.zillowstatic.com/fp/170bda4ccf2323fd745e77cdb1003b89-p_d.jpg",
        "https://photos.zillowstatic.com/fp/419fc5d6553136c824b7fe17926a4c38-p_d.jpg",
        "https://photos.zillowstatic.com/fp/b4d989e4b1edb96fd78beb248a48f865-p_d.jpg",
        "https://photos.zillowstatic.com/fp/30330f64710b9b0ce6e20c39c896870c-p_d.jpg",
        "https://photos.zillowstatic.com/fp/e11ddad4cf905538402ed3c8c3baba16-p_d.jpg",
        "https://photos.zillowstatic.com/fp/b44413020c05ec268b417d34a2b53d5d-p_d.jpg"
      ],
      "homeStatus": "FOR_SALE",
      "price": 500,
      "rating": 0.1,
      "type": "House",
      "address": {
        "streetAddress": "401 Lomond Ave",
        "city": "Los Angeles",
        "state": "CA",
        "zipcode": "90024",
        "neighborhood": null,
        "community": null,
        "subdivision": null
      },
      "yearBuilt": 1935,
      "bedrooms": 6,
      "bathrooms": 6,
      "livingArea": 4192,
      "url": "https://www.zillow.com/homedetails/401-Lomond-Ave-Los-Angeles-CA-90024/20524203_zpid/",
      "_id": "m1ylkhn3sw",
      "__index": 36
    },
    {
      "photos": [
        "https://photos.zillowstatic.com/fp/235b646fe415508886937619dcb2854d-p_d.jpg",
        "https://photos.zillowstatic.com/fp/ff4c5a38e47282ef7dd3211919eff668-p_d.jpg",
        "https://photos.zillowstatic.com/fp/9459c2dd0aed3fc951fdc7561d655c3c-p_d.jpg",
        "https://photos.zillowstatic.com/fp/392af9cbc2619d60e9744c7fb170afb2-p_d.jpg",
        "https://photos.zillowstatic.com/fp/1250a27eb876941614de22e17a9a00a1-p_d.jpg",
        "https://photos.zillowstatic.com/fp/3663eb742ec0ef4b90f27a46d19d83c0-p_d.jpg",
        "https://photos.zillowstatic.com/fp/4151c9f14ffe87098253116fb4b99c6f-p_d.jpg",
        "https://photos.zillowstatic.com/fp/961195198a7f6df2804cc3fd52c529a3-p_d.jpg",
        "https://photos.zillowstatic.com/fp/3c0f8bc6779bceb0e5cd0fcba881a089-p_d.jpg",
        "https://photos.zillowstatic.com/fp/461cf926a4fe375e9d487dc34606ee61-p_d.jpg",
        "https://photos.zillowstatic.com/fp/1bc864e9427d646028d3911dd42a3c01-p_d.jpg"
      ],
      "homeStatus": "FOR_SALE",
      "price": 2000,
      "rating": 5.8,
      "type": "Guest House",
      "address": {
        "streetAddress": "1819 Workman St",
        "city": "Los Angeles",
        "state": "CA",
        "zipcode": "90031",
        "neighborhood": null,
        "community": null,
        "subdivision": null
      },
      "yearBuilt": 1887,
      "bedrooms": 34,
      "bathrooms": 21,
      "livingArea": 2869,
      "url": "https://www.zillow.com/homedetails/1819-Workman-St-Los-Angeles-CA-90031/250335381_zpid/",
      "_id": "b6p855crjm",
      "__index": 37
    },
    {
      "photos": [
        "https://photos.zillowstatic.com/fp/b4f282e05381fffd1dfe40e29ba8c5e7-p_d.jpg",
        "https://photos.zillowstatic.com/fp/c197fb37e7c7a66c9bdb73d62fd67705-p_d.jpg",
        "https://photos.zillowstatic.com/fp/1e5970831d685df2fdc2e854073f6fb7-p_d.jpg",
        "https://photos.zillowstatic.com/fp/ceb4750f7aa9ebfd50b94c78c037cda5-p_d.jpg",
        "https://photos.zillowstatic.com/fp/6c744ec988783fde13eb2f432da8826f-p_d.jpg",
        "https://photos.zillowstatic.com/fp/74a3a1a6a569101e4408487a861b727d-p_d.jpg",
        "https://photos.zillowstatic.com/fp/cc28926638e3c81728fcb3daee0ecd63-p_d.jpg",
        "https://photos.zillowstatic.com/fp/91e6eb2f4e17ca4be5a373b8f00a48e4-p_d.jpg",
        "https://photos.zillowstatic.com/fp/122afc365a2e22023e078a478fe8db83-p_d.jpg",
        "https://photos.zillowstatic.com/fp/41ac6c5fa1f4d642bb0a81945e6b5eb2-p_d.jpg",
        "https://photos.zillowstatic.com/fp/03eac3e83c51ce7cd2dc809af0d5c336-p_d.jpg",
        "https://photos.zillowstatic.com/fp/34713ca4f7df85b0e957f2e523fe7aa2-p_d.jpg",
        "https://photos.zillowstatic.com/fp/b0ff4b6a10bc64735b5fb3fa25a68c6b-p_d.jpg",
        "https://photos.zillowstatic.com/fp/96fc8d65f19566b455e990ea0c54c3ad-p_d.jpg",
        "https://photos.zillowstatic.com/fp/6a854a7af8cc767203714b52aaf57fce-p_d.jpg",
        "https://photos.zillowstatic.com/fp/25edf2de0ac6c89e203f39e2d244b2c3-p_d.jpg",
        "https://photos.zillowstatic.com/fp/294f2a6d6214c800fd25c362b435593c-p_d.jpg",
        "https://photos.zillowstatic.com/fp/3c7a0dc3381eec781da4fe844ac947d9-p_d.jpg",
        "https://photos.zillowstatic.com/fp/4b854b230fc2400771c63997c473a121-p_d.jpg",
        "https://photos.zillowstatic.com/fp/d2ebc129644c4dd1d9f91b228e7d9a9d-p_d.jpg",
        "https://photos.zillowstatic.com/fp/810e331e24a7016dc8da42be75dcdbe3-p_d.jpg",
        "https://photos.zillowstatic.com/fp/96e94ba3346502bd8e7e67ec00a8478b-p_d.jpg",
        "https://photos.zillowstatic.com/fp/5b8f16b96c5d6b161d7432558adb0548-p_d.jpg",
        "https://photos.zillowstatic.com/fp/ec23650a714c8e0883a0159929d0ad02-p_d.jpg",
        "https://photos.zillowstatic.com/fp/9e1d46b0ac7b7c494be31f60b5f33508-p_d.jpg",
        "https://photos.zillowstatic.com/fp/95ec537d290d33f32541fbdc66137aee-p_d.jpg",
        "https://photos.zillowstatic.com/fp/53e3fef798779f84546fde4d16972d21-p_d.jpg",
        "https://photos.zillowstatic.com/fp/ab9c14d19867080c5eed24155cd382cf-p_d.jpg",
        "https://photos.zillowstatic.com/fp/d93976354372ec08082da2a239736c46-p_d.jpg",
        "https://photos.zillowstatic.com/fp/ea681ab53bdadf96b545de13bd2f34ea-p_d.jpg",
        "https://photos.zillowstatic.com/fp/d73eabbce3be1350ca0dd92cca47554d-p_d.jpg"
      ],
      "homeStatus": "FOR_SALE",
      "price": 1950,
      "rating": 3.1,
      "type": "Villa",
      "address": {
        "streetAddress": "1450 Brett Pl",
        "city": "San Pedro",
        "state": "CA",
        "zipcode": "90732",
        "neighborhood": null,
        "community": null,
        "subdivision": null
      },
      "yearBuilt": 1986,
      "bedrooms": 2,
      "bathrooms": 2,
      "livingArea": 1304,
      "url": "https://www.zillow.com/homedetails/1450-Brett-Pl-San-Pedro-CA-90732/21303851_zpid/",
      "_id": "4mrhcpp65p",
      "__index": 38
    },
    {
      "photos": [
        "https://photos.zillowstatic.com/fp/40b774893f1b5c6a7207b54abd542c7d-p_d.jpg",
        "https://photos.zillowstatic.com/fp/4162e4793a2ac9c49fe60121a8a922c6-p_d.jpg",
        "https://photos.zillowstatic.com/fp/e53ead093def5e6722c2fea84e732a33-p_d.jpg",
        "https://photos.zillowstatic.com/fp/19ce0ec4d44058819e11e069478c9301-p_d.jpg",
        "https://photos.zillowstatic.com/fp/7dce4e0c18cf0516bcdfa4f43710c58e-p_d.jpg",
        "https://photos.zillowstatic.com/fp/38df514f666181a8734fb16175a02218-p_d.jpg",
        "https://photos.zillowstatic.com/fp/0b6c0e8dfc4f648b36991ca739e1b34d-p_d.jpg",
        "https://photos.zillowstatic.com/fp/1ac1c9fc0f789e89631c747fb3a07c82-p_d.jpg",
        "https://photos.zillowstatic.com/fp/4c2a005278a57528a5457b09c27f1e27-p_d.jpg",
        "https://photos.zillowstatic.com/fp/5840ebe9950095eb7e11b9fb12a24c1b-p_d.jpg",
        "https://photos.zillowstatic.com/fp/6ca8e2e11b835f299ff87ef50e2de3f9-p_d.jpg",
        "https://photos.zillowstatic.com/fp/af765ec3d9a4557dad1187e4a6c6f0e9-p_d.jpg",
        "https://photos.zillowstatic.com/fp/a281476e92dfc4c3f0d87173775546d6-p_d.jpg",
        "https://photos.zillowstatic.com/fp/4f11738d964f053db8088b3141ebb172-p_d.jpg",
        "https://photos.zillowstatic.com/fp/dfabcda98c47c7234c55f4b2a39af71d-p_d.jpg",
        "https://photos.zillowstatic.com/fp/b1258e904fed3768de7531e02600b205-p_d.jpg",
        "https://photos.zillowstatic.com/fp/6e5b3ee902a20f5ddf3c76d9fa1c91c8-p_d.jpg",
        "https://photos.zillowstatic.com/fp/5af1eb570a968c6d8dbdeb7c0793a844-p_d.jpg",
        "https://photos.zillowstatic.com/fp/35495ee6bf197ba45332d11231ff13f3-p_d.jpg",
        "https://photos.zillowstatic.com/fp/7a30f380b08803dbb1f3c0ebd4740c3c-p_d.jpg",
        "https://photos.zillowstatic.com/fp/6faf59d872bbcf305738b3a7dfc5e907-p_d.jpg",
        "https://photos.zillowstatic.com/fp/4f4d6dd33c07257eb007bbefa16c6aad-p_d.jpg",
        "https://photos.zillowstatic.com/fp/e6c56ea628a28c98ad0e8f5e024e0423-p_d.jpg",
        "https://photos.zillowstatic.com/fp/55f99008acad70224b53f2ac36b5d46e-p_d.jpg",
        "https://photos.zillowstatic.com/fp/f903cdbd1afbd5d16b59a1d51e2a6c47-p_d.jpg",
        "https://photos.zillowstatic.com/fp/f4616663f21f7c086cf0d2f8aacff798-p_d.jpg",
        "https://photos.zillowstatic.com/fp/1fd445861b79c53064dee167395c55b9-p_d.jpg",
        "https://photos.zillowstatic.com/fp/a344e1189c0ad961003d721ba8d3f6a8-p_d.jpg",
        "https://photos.zillowstatic.com/fp/b3755697a1074803a9d5085890dacc07-p_d.jpg",
        "https://photos.zillowstatic.com/fp/6f61a05eec79b4bdc844461b381093b0-p_d.jpg",
        "https://photos.zillowstatic.com/fp/874052a041435f322aef4ccc0cc06617-p_d.jpg",
        "https://photos.zillowstatic.com/fp/53ed6f61a1a8999b2069249e840bacd4-p_d.jpg",
        "https://photos.zillowstatic.com/fp/df2c581717a862ebb450c01f973a19de-p_d.jpg",
        "https://photos.zillowstatic.com/fp/d4d1e46b3e14cad392f9de804b4b81b0-p_d.jpg",
        "https://photos.zillowstatic.com/fp/90491bcc5c91b2730c5574e0b5690adf-p_d.jpg",
        "https://photos.zillowstatic.com/fp/163f1bec5bfa3b3fc5044348ea5200b5-p_d.jpg",
        "https://photos.zillowstatic.com/fp/0cf2987b2efdd276fba463088ce8aec3-p_d.jpg",
        "https://photos.zillowstatic.com/fp/dccf726bb13110614133b207993fdae8-p_d.jpg",
        "https://photos.zillowstatic.com/fp/cbae3b872ea1020911b78e35a824a6b7-p_d.jpg",
        "https://photos.zillowstatic.com/fp/34fa9ca32f390d87b92a4a15e64adbf0-p_d.jpg",
        "https://photos.zillowstatic.com/fp/d27dbf97ee5684d957cca034db4554bc-p_d.jpg",
        "https://photos.zillowstatic.com/fp/4f04ce074a6c5a3fe3906784714a1508-p_d.jpg",
        "https://photos.zillowstatic.com/fp/3ca602aa58397babb42caa1e33d55aa9-p_d.jpg",
        "https://photos.zillowstatic.com/fp/af29ed579471402a4f9ab400b86c680f-p_d.jpg"
      ],
      "homeStatus": "FOR_SALE",
      "price": 1295,
      "rating": 8.1,
      "type": "Condo",
      "address": {
        "streetAddress": "4937 Aldama St",
        "city": "Los Angeles",
        "state": "CA",
        "zipcode": "90042",
        "neighborhood": null,
        "community": null,
        "subdivision": null
      },
      "yearBuilt": 1909,
      "bedrooms": 3,
      "bathrooms": 2,
      "livingArea": 1473,
      "url": "https://www.zillow.com/homedetails/4937-Aldama-St-Los-Angeles-CA-90042/20763339_zpid/",
      "_id": "fb7g48d1plc",
      "__index": 39
    },
    {
      "photos": [
        "https://maps.googleapis.com/maps/api/streetview?location=3618+Montalvo+St%2C+Los+Angeles%2C+CA+90065&size=400x300&key=AIzaSyARFMLB1na-BBWf7_R3-5YOQQaHqEJf6RQ&source=outdoor&&signature=i9aTxQAlf0g9OxekEA7sASOvDeU="
      ],
      "homeStatus": "FOR_SALE",
      "price": 4875,
      "rating": 4.6,
      "type": "Condo",
      "address": {
        "streetAddress": "3618 Montalvo St",
        "city": "Los Angeles",
        "state": "CA",
        "zipcode": "90065",
        "neighborhood": null,
        "community": null,
        "subdivision": null
      },
      "yearBuilt": null,
      "bedrooms": 0,
      "bathrooms": 0,
      "livingArea": null,
      "url": "https://www.zillow.com/homedetails/3618-Montalvo-St-Los-Angeles-CA-90065/2060775353_zpid/",
      "_id": "tcd1fqhc3oo",
      "__index": 40
    },
    {
      "photos": [
        "https://photos.zillowstatic.com/fp/d834913b69c4ab2967c6ba3664396901-p_d.jpg",
        "https://photos.zillowstatic.com/fp/6b137a163308ec379abc60c6ac2acdfa-p_d.jpg",
        "https://photos.zillowstatic.com/fp/0190a960cb39f4f8da70b9eef6ef79bf-p_d.jpg",
        "https://photos.zillowstatic.com/fp/0d27a07bdf889dbb2d77c9b2b507b1bd-p_d.jpg",
        "https://photos.zillowstatic.com/fp/6129b65b9101d3b0b2c503500e7626e5-p_d.jpg",
        "https://photos.zillowstatic.com/fp/10ffc4c36af4f8a379b0c521a38dc45a-p_d.jpg",
        "https://photos.zillowstatic.com/fp/b6a9dff10088573e20c2fc468f07e4b0-p_d.jpg",
        "https://photos.zillowstatic.com/fp/b3f307f12bede02feec87861c783ff1e-p_d.jpg",
        "https://photos.zillowstatic.com/fp/afa313b49dc6f173b4c8471db6756ff1-p_d.jpg",
        "https://photos.zillowstatic.com/fp/1bb7a00844b17bd5ee94986fe89232c3-p_d.jpg",
        "https://photos.zillowstatic.com/fp/5ee0beaccae45c10242d9f22d6865bd8-p_d.jpg",
        "https://photos.zillowstatic.com/fp/cf2c138e4259aa40a782b767fefc8978-p_d.jpg",
        "https://photos.zillowstatic.com/fp/c64ff60b8fe243812f64f659e3ec032a-p_d.jpg",
        "https://photos.zillowstatic.com/fp/52486d731f958713cb0c49aa8ce99cfb-p_d.jpg",
        "https://photos.zillowstatic.com/fp/0af04607472687e963d3e6ed45e5ddb1-p_d.jpg",
        "https://photos.zillowstatic.com/fp/c0552999d9abf8d59416eb5afb01965f-p_d.jpg",
        "https://photos.zillowstatic.com/fp/eb41c034665fbd9bbd038921a59f2990-p_d.jpg",
        "https://photos.zillowstatic.com/fp/2eb022a250529ae5f44e1142ddd2d5ce-p_d.jpg",
        "https://photos.zillowstatic.com/fp/fa1e646eebee33b00bcd652cbecc45b9-p_d.jpg",
        "https://photos.zillowstatic.com/fp/fb95ebad3953e226de6753079a724358-p_d.jpg",
        "https://photos.zillowstatic.com/fp/b9c61d2fa60e2f2c3d8012ed5e83e76a-p_d.jpg",
        "https://photos.zillowstatic.com/fp/536dbbfaabf693205e4160a713c1ab3d-p_d.jpg",
        "https://photos.zillowstatic.com/fp/786b69eb90f2e3b8ae25fb9dec3d90c7-p_d.jpg",
        "https://photos.zillowstatic.com/fp/5e9f1e808c1e6c6fabc7123af323838e-p_d.jpg",
        "https://photos.zillowstatic.com/fp/d834913b69c4ab2967c6ba3664396901-p_d.jpg"
      ],
      "homeStatus": "FOR_SALE",
      "price": 3377,
      "rating": 9.2,
      "type": "Guest House",
      "address": {
        "streetAddress": "10710 Belmar Ave",
        "city": "Porter Ranch",
        "state": "CA",
        "zipcode": "91326",
        "neighborhood": null,
        "community": null,
        "subdivision": null
      },
      "yearBuilt": 1968,
      "bedrooms": 4,
      "bathrooms": 3,
      "livingArea": 3350,
      "url": "https://www.zillow.com/homedetails/10710-Belmar-Ave-Porter-Ranch-CA-91326/20158796_zpid/",
      "_id": "apmy324f3t",
      "__index": 41
    },
    {
      "photos": [
        "https://photos.zillowstatic.com/fp/0874eee5a2f014ca56db11e7e97ed952-p_d.jpg",
        "https://photos.zillowstatic.com/fp/2a43fc94d2732e92c0a44e69a3ac6834-p_d.jpg",
        "https://photos.zillowstatic.com/fp/802d160fcefb4e64edd1868fafb281c3-p_d.jpg",
        "https://photos.zillowstatic.com/fp/65723aec23c74ef5ce7d82146fc88faf-p_d.jpg",
        "https://photos.zillowstatic.com/fp/a27ad01ef5e94486c6bab124049b7ec9-p_d.jpg",
        "https://photos.zillowstatic.com/fp/74fbf0bb7ece2f0f4e3a542bcda9f7a2-p_d.jpg",
        "https://photos.zillowstatic.com/fp/ae46c8a02149a0428139567ac2bb1957-p_d.jpg",
        "https://photos.zillowstatic.com/fp/551c3e720ae60b31eb0aae2876ef7d34-p_d.jpg",
        "https://photos.zillowstatic.com/fp/97e2e0c286584d380ca51b289afdf683-p_d.jpg",
        "https://photos.zillowstatic.com/fp/9becdcf4f4d3b7d780b4a3ea4c1596ad-p_d.jpg",
        "https://photos.zillowstatic.com/fp/614f747cc807a9bc6351d8ade6881e0e-p_d.jpg",
        "https://photos.zillowstatic.com/fp/268d2c290d546014654132cfadd4a3f1-p_d.jpg",
        "https://photos.zillowstatic.com/fp/38d1df4d39ad8c46d657416a9b1c2544-p_d.jpg",
        "https://photos.zillowstatic.com/fp/7b814d529f037c3a082ee542517a265a-p_d.jpg",
        "https://photos.zillowstatic.com/fp/d256e19a32696a8e3c0cb00f13fa9e34-p_d.jpg",
        "https://photos.zillowstatic.com/fp/32ed9377a76a47e563dc7936fc2ac1da-p_d.jpg",
        "https://photos.zillowstatic.com/fp/5e175d4aa85c7006407847dc59756b12-p_d.jpg",
        "https://photos.zillowstatic.com/fp/f8a36dcd66d0fa851038cf8f8145e00a-p_d.jpg",
        "https://photos.zillowstatic.com/fp/b9b42406c70b615da2c025a2e8b5a81a-p_d.jpg",
        "https://photos.zillowstatic.com/fp/5ca2fc3b95ef1fc04170c2f4d243b4e7-p_d.jpg",
        "https://photos.zillowstatic.com/fp/3eaa703c23d533a773829c69814b6c4c-p_d.jpg",
        "https://photos.zillowstatic.com/fp/6bd32e59147fa782da8edfc72fec5c9a-p_d.jpg",
        "https://photos.zillowstatic.com/fp/bddff5401b0bd7d44a825d79e4fa6a3e-p_d.jpg",
        "https://photos.zillowstatic.com/fp/f4f76e89035b1de069da88c256d176b4-p_d.jpg",
        "https://photos.zillowstatic.com/fp/ee130bd6533812821e27ac2059209e45-p_d.jpg",
        "https://photos.zillowstatic.com/fp/a795add59a59c8f784467ece0e828edf-p_d.jpg",
        "https://photos.zillowstatic.com/fp/20b092156d46237e8cc00e21b2509cf8-p_d.jpg",
        "https://photos.zillowstatic.com/fp/233a0dca0962afa542e33cbb9f6d36c2-p_d.jpg",
        "https://photos.zillowstatic.com/fp/f17d1eaf44b874a71d6774b96ff6a963-p_d.jpg",
        "https://photos.zillowstatic.com/fp/ab246c876507d4875475b325a5ac48d5-p_d.jpg",
        "https://photos.zillowstatic.com/fp/c1979968c03b6a362c14fbe06b6a2f12-p_d.jpg",
        "https://photos.zillowstatic.com/fp/56fd74c62b6b7064c4598461b0f68d84-p_d.jpg",
        "https://photos.zillowstatic.com/fp/a1419e4d1efa85564a3ef96031b3d733-p_d.jpg",
        "https://photos.zillowstatic.com/fp/c9869b22503ab4405dcaf60e43a7187c-p_d.jpg",
        "https://photos.zillowstatic.com/fp/a5a2cf6f7dcc774f7e10b07a8177ef35-p_d.jpg",
        "https://photos.zillowstatic.com/fp/f26ec1be17597f700ced75224b595f42-p_d.jpg",
        "https://photos.zillowstatic.com/fp/942c3ff16b6ebe002fafecafbe2ad3ce-p_d.jpg",
        "https://photos.zillowstatic.com/fp/c24a9088807d261580d48d9b61bb94f6-p_d.jpg",
        "https://photos.zillowstatic.com/fp/99771938571d1c8af56bdfb18c060480-p_d.jpg",
        "https://photos.zillowstatic.com/fp/d78ce5a9e3b34c4cb667651b603cf262-p_d.jpg",
        "https://photos.zillowstatic.com/fp/811b711f60f7ef0670a2ea5bffc3e1f3-p_d.jpg",
        "https://photos.zillowstatic.com/fp/ac26bfc8d812a3ca85568b5deb49f1d2-p_d.jpg",
        "https://photos.zillowstatic.com/fp/87fb0a3dd12699ffe90cce813a48b891-p_d.jpg",
        "https://photos.zillowstatic.com/fp/903260658f46e3bb2223a77ba72ed34b-p_d.jpg",
        "https://photos.zillowstatic.com/fp/a2c738a569800f19dec5be682d9a5fa3-p_d.jpg",
        "https://photos.zillowstatic.com/fp/f910f46a0361c98bb77f951a5b1a5b02-p_d.jpg",
        "https://photos.zillowstatic.com/fp/9d1f4eadf98268a97a904e4d712c91c9-p_d.jpg",
        "https://photos.zillowstatic.com/fp/c9148a6262cacdd67b303fb30c611563-p_d.jpg",
        "https://photos.zillowstatic.com/fp/f458dc1fb5b28d9a246895b6d4c58f61-p_d.jpg",
        "https://photos.zillowstatic.com/fp/9d452755bb69cbfd6c6b855a26c68384-p_d.jpg",
        "https://photos.zillowstatic.com/fp/b9af10b0e68793c1982085571528e5eb-p_d.jpg",
        "https://photos.zillowstatic.com/fp/2c02960b8271c00fabab8f30a98ab867-p_d.jpg",
        "https://photos.zillowstatic.com/fp/f1ba6a53b4073fc8abe98410966880fa-p_d.jpg",
        "https://photos.zillowstatic.com/fp/a352a0d7d416d0979489042e3b4f4059-p_d.jpg",
        "https://photos.zillowstatic.com/fp/197545a3d390291124f270eec2934390-p_d.jpg",
        "https://photos.zillowstatic.com/fp/c80c4b927a85a29d056aa28f424aa8dc-p_d.jpg",
        "https://photos.zillowstatic.com/fp/60d66996c0a880d9497282ed73672c49-p_d.jpg",
        "https://photos.zillowstatic.com/fp/8d94968af0c933a49d0535b505b21a79-p_d.jpg",
        "https://photos.zillowstatic.com/fp/e70656b5325bdbb34d275dbe91f94b25-p_d.jpg",
        "https://photos.zillowstatic.com/fp/1b4afce0cb277c5cd930f697bd80cb5a-p_d.jpg",
        "https://photos.zillowstatic.com/fp/af074ec180408ff21028625f24b5a24b-p_d.jpg",
        "https://photos.zillowstatic.com/fp/075a73c647d9b0961126f67a70429363-p_d.jpg",
        "https://photos.zillowstatic.com/fp/99d54932d7080d2b29093605124e8401-p_d.jpg",
        "https://photos.zillowstatic.com/fp/346bb03e01fb153394f7d77fb90bcabd-p_d.jpg",
        "https://photos.zillowstatic.com/fp/5b6ef25ff5b23af4181608a75681381a-p_d.jpg",
        "https://photos.zillowstatic.com/fp/d400239e0cc9c1fb6d2fe7d95537d6a2-p_d.jpg",
        "https://photos.zillowstatic.com/fp/382ac2e0f1543e83bc501dffc64ed539-p_d.jpg",
        "https://photos.zillowstatic.com/fp/26851a8f67cec92c6f9a4ccc41d6298a-p_d.jpg",
        "https://photos.zillowstatic.com/fp/f5580e3e94bef7eed8b2fdc63f1fbdaa-p_d.jpg",
        "https://photos.zillowstatic.com/fp/5b50061581f02e1f9e4062afd29c3c0c-p_d.jpg",
        "https://photos.zillowstatic.com/fp/eceea8373b8fd477dde0442dfc3248c3-p_d.jpg",
        "https://photos.zillowstatic.com/fp/47bbbd72d5a808e4b5947500398e674e-p_d.jpg",
        "https://photos.zillowstatic.com/fp/2c5a53b3c865a93373247a14dc39803f-p_d.jpg",
        "https://photos.zillowstatic.com/fp/8223a88ee44f9e7b33dcc1dce51cdb7f-p_d.jpg",
        "https://photos.zillowstatic.com/fp/216f678f800d677157fcc2110eb526b6-p_d.jpg",
        "https://photos.zillowstatic.com/fp/0c876b26faa1bf85a1558345fa2f3561-p_d.jpg",
        "https://photos.zillowstatic.com/fp/bd84043eaa5559f07936955909af58e1-p_d.jpg",
        "https://photos.zillowstatic.com/fp/46a3c193cc3bde92d5d6e3e364525ea0-p_d.jpg",
        "https://photos.zillowstatic.com/fp/92f3b4f5b2ea6698dfdc9cc6262a045e-p_d.jpg",
        "https://photos.zillowstatic.com/fp/5ab2636b1573804d849d9589159abe62-p_d.jpg",
        "https://photos.zillowstatic.com/fp/967c260359ac029595e309b5a5b76c1c-p_d.jpg",
        "https://photos.zillowstatic.com/fp/1cee3dc1ef4c18e0dd974712856ea8c2-p_d.jpg",
        "https://photos.zillowstatic.com/fp/677c7985d87cd175950aa984deeb6433-p_d.jpg",
        "https://photos.zillowstatic.com/fp/9c19a639f27c5029b72589b984a4bae1-p_d.jpg",
        "https://photos.zillowstatic.com/fp/f3847d7bad0529c9d64b59ff6cfd3faf-p_d.jpg",
        "https://photos.zillowstatic.com/fp/a23b413a5f2515e7253c71661a8794b7-p_d.jpg",
        "https://photos.zillowstatic.com/fp/0677e399bba8a92246d5d28a26b733f2-p_d.jpg",
        "https://photos.zillowstatic.com/fp/27fc8acef036b1388edf536c41dd3cbe-p_d.jpg",
        "https://photos.zillowstatic.com/fp/1847e09a9db94ef16fba75ed69ced22e-p_d.jpg"
      ],
      "homeStatus": "FOR_SALE",
      "price": 3999,
      "rating": 5.9,
      "title": "Villa",
      "address": {
        "streetAddress": "1336 N Tigertail Rd",
        "city": "Los Angeles",
        "state": "CA",
        "zipcode": "90049",
        "neighborhood": null,
        "community": null,
        "subdivision": null
      },
      "yearBuilt": 1961,
      "bedrooms": 4,
      "bathrooms": 5,
      "livingArea": 3000,
      "url": "https://www.zillow.com/homedetails/1336-N-Tigertail-Rd-Los-Angeles-CA-90049/20559721_zpid/",
      "_id": "3w5e5zvc3dq",
      "__index": 42
    },
    {
      "photos": [
        "https://photos.zillowstatic.com/fp/7b06e1ae1e8a2fcbbf62dd7f8ffce7ef-p_d.jpg",
        "https://photos.zillowstatic.com/fp/e47e57f2eb9eeacc14c46d537da23c89-p_d.jpg",
        "https://photos.zillowstatic.com/fp/0cd91b3a291fe5c01532a7e585b71865-p_d.jpg",
        "https://photos.zillowstatic.com/fp/82b1801056c3f9a8fad2f516d727a44a-p_d.jpg",
        "https://photos.zillowstatic.com/fp/3ce8e6468e2dbea59e0f69746f08150d-p_d.jpg",
        "https://photos.zillowstatic.com/fp/dec5e63d26038a889645c3f757bd46c7-p_d.jpg",
        "https://photos.zillowstatic.com/fp/f6e17b8c9a19fe4263bbc17fd97e53ec-p_d.jpg",
        "https://photos.zillowstatic.com/fp/e0b1162df0a1411ec18514e89b4e4eda-p_d.jpg",
        "https://photos.zillowstatic.com/fp/3c6ae9f7c2d0daed6eb8afe00c1f0d41-p_d.jpg",
        "https://photos.zillowstatic.com/fp/e9b665ee8acd70a571968fe1c97584ca-p_d.jpg",
        "https://photos.zillowstatic.com/fp/f9a110dcc4adc48b8ef9a2684729a805-p_d.jpg",
        "https://photos.zillowstatic.com/fp/592ce298d47e46b45875ba0f2bde9b16-p_d.jpg",
        "https://photos.zillowstatic.com/fp/9af806a3134cf1726e8478b5018e9d3e-p_d.jpg",
        "https://photos.zillowstatic.com/fp/a1581215ba2995143966150e9e4bb763-p_d.jpg",
        "https://photos.zillowstatic.com/fp/db040a7a00c3ccdcbda867305d155f0f-p_d.jpg",
        "https://photos.zillowstatic.com/fp/c3aafe1c5c807d3b4ed1132a853a5cd9-p_d.jpg",
        "https://photos.zillowstatic.com/fp/56d3d28dfa7c02ea4294bf4a175b3ca7-p_d.jpg"
      ],
      "homeStatus": "FOR_SALE",
      "price": 1459,
      "rating": 2.2,
      "type": "Condo",
      "address": {
        "streetAddress": "24303 Woolsey Canyon Rd SPACE 26",
        "city": "Canoga Park",
        "state": "CA",
        "zipcode": "91304",
        "neighborhood": null,
        "community": null,
        "subdivision": null
      },
      "yearBuilt": 1980,
      "bedrooms": 2,
      "bathrooms": 2,
      "livingArea": 1248,
      "url": "https://www.zillow.com/homedetails/24303-Woolsey-Canyon-Rd-SPACE-26-Canoga-Park-CA-91304/145644957_zpid/",
      "_id": "101rk1q2dsk",
      "__index": 43
    },
    {
      "photos": [
        "https://photos.zillowstatic.com/fp/6760335958fd9c476cb3cfc7d78fee28-p_d.jpg",
        "https://photos.zillowstatic.com/fp/506c5876d9af7708c34c7f91d6b8f202-p_d.jpg",
        "https://photos.zillowstatic.com/fp/11fffe9bfab53097b382064c18f9c757-p_d.jpg",
        "https://photos.zillowstatic.com/fp/65db6633c9789bd23a323bd447981090-p_d.jpg",
        "https://photos.zillowstatic.com/fp/180e9466f3807c70d2f08a67b3dadb3b-p_d.jpg",
        "https://photos.zillowstatic.com/fp/9321e62b2674d4cf91a0176375cd11eb-p_d.jpg",
        "https://photos.zillowstatic.com/fp/e41c695a5812ec534858de51a02770a0-p_d.jpg",
        "https://photos.zillowstatic.com/fp/74fc683373c12d489c338af889d8aabd-p_d.jpg",
        "https://photos.zillowstatic.com/fp/85fa5c83b4111f03d28f222081a21d7d-p_d.jpg",
        "https://photos.zillowstatic.com/fp/d61d69eecaa491a8cc821a447f71a717-p_d.jpg",
        "https://photos.zillowstatic.com/fp/b90e3f4da2497a2e1aa6d7828672a46e-p_d.jpg",
        "https://photos.zillowstatic.com/fp/095e1d316edacbdc57dc0ec95d16e210-p_d.jpg",
        "https://photos.zillowstatic.com/fp/13fcb4be65621b28ae01eaacddc9e1d6-p_d.jpg",
        "https://photos.zillowstatic.com/fp/96ce7fff82d925f99fb1203324981a66-p_d.jpg",
        "https://photos.zillowstatic.com/fp/df247589b6931f7bdb3860552ebf1d7d-p_d.jpg",
        "https://photos.zillowstatic.com/fp/649a4146cad1226722966868a00b4f6d-p_d.jpg",
        "https://photos.zillowstatic.com/fp/79a6c9d88236329f2c6b09a73cac2689-p_d.jpg",
        "https://photos.zillowstatic.com/fp/745b57b738923c04d935da3a00527a6c-p_d.jpg",
        "https://photos.zillowstatic.com/fp/5da8030245bded6a800c32651180e59c-p_d.jpg",
        "https://photos.zillowstatic.com/fp/b82b83f1288e7b3997752f1dd0e09976-p_d.jpg",
        "https://photos.zillowstatic.com/fp/9abe03f10b8620bb9e474044a399153e-p_d.jpg",
        "https://photos.zillowstatic.com/fp/d5abfa1abf01466859424311cd11491e-p_d.jpg",
        "https://photos.zillowstatic.com/fp/f0d691fa8a7a453ba0dff97cf2b8d306-p_d.jpg",
        "https://photos.zillowstatic.com/fp/5c4994a602cbf047f21b2056c5401cac-p_d.jpg",
        "https://photos.zillowstatic.com/fp/86b54d0d402d729ae5f803cda7bbfb18-p_d.jpg",
        "https://photos.zillowstatic.com/fp/c79df299b08ff12fe18c11aa8ade3676-p_d.jpg",
        "https://photos.zillowstatic.com/fp/18f50233c4c4582702c281de26035890-p_d.jpg",
        "https://photos.zillowstatic.com/fp/84802ec81963d958e2790c5ad7d2f35a-p_d.jpg",
        "https://photos.zillowstatic.com/fp/f69d74360aae2276e5027c0cd7eaa012-p_d.jpg",
        "https://photos.zillowstatic.com/fp/b328ce6a43b95be5dec933064220f4db-p_d.jpg",
        "https://photos.zillowstatic.com/fp/2d54a1c36197947dc30b4818f21e1c0e-p_d.jpg",
        "https://photos.zillowstatic.com/fp/f87425a0f60a9bfa6d29f9079a6a1972-p_d.jpg",
        "https://photos.zillowstatic.com/fp/b50da65b4d5d24098715f4dcc28c01e2-p_d.jpg",
        "https://photos.zillowstatic.com/fp/13790c50dbf78aba74789097c94f8099-p_d.jpg",
        "https://photos.zillowstatic.com/fp/a03140458451cdf773c13ff891dff375-p_d.jpg",
        "https://photos.zillowstatic.com/fp/c5760abcda506306e3d41e1577bc9182-p_d.jpg",
        "https://photos.zillowstatic.com/fp/1e099d942ba1bacffec6a8e14f23423c-p_d.jpg",
        "https://photos.zillowstatic.com/fp/a9c7d84706a54b433ad5cc57f817850d-p_d.jpg",
        "https://photos.zillowstatic.com/fp/e79154787a937a482522ccf3774deae8-p_d.jpg",
        "https://photos.zillowstatic.com/fp/91c685c0ccf22bad413339eb73785279-p_d.jpg",
        "https://photos.zillowstatic.com/fp/c1a762a34bbe6ebf1cff49bcec195888-p_d.jpg",
        "https://photos.zillowstatic.com/fp/08ca763c4434f685e282640e5d518501-p_d.jpg",
        "https://photos.zillowstatic.com/fp/da829b1f937ba6405437f6c094694ac8-p_d.jpg",
        "https://photos.zillowstatic.com/fp/e2881c342e7f0a0320ccb71b3f33c117-p_d.jpg",
        "https://photos.zillowstatic.com/fp/adcbb2d269b733436bd67cf24f1c5121-p_d.jpg",
        "https://photos.zillowstatic.com/fp/2f39b7b009c9df94c5ec10e19f4c35a3-p_d.jpg",
        "https://photos.zillowstatic.com/fp/e45b3d3ad688d960d1aef556bb552ce8-p_d.jpg",
        "https://photos.zillowstatic.com/fp/cb026dc1565c4a9afcd421a2f288815c-p_d.jpg",
        "https://photos.zillowstatic.com/fp/e8677aaf0f427afd0762dc2b04bc5095-p_d.jpg",
        "https://photos.zillowstatic.com/fp/38abce981f2c0094a8494e3414f91962-p_d.jpg",
        "https://photos.zillowstatic.com/fp/309a13a6e775283b9456c41374b051da-p_d.jpg",
        "https://photos.zillowstatic.com/fp/ca5a981728cde92759f3a781f6e86e12-p_d.jpg",
        "https://photos.zillowstatic.com/fp/fcd49a2f9c3e3bfa6a60344c5723b5ad-p_d.jpg",
        "https://photos.zillowstatic.com/fp/3a8faed8d7aefbf784db74a27488397e-p_d.jpg",
        "https://photos.zillowstatic.com/fp/859a2048cc2053e9380e1736341efee7-p_d.jpg",
        "https://photos.zillowstatic.com/fp/350bc5731d2d215d44d453bdd51d71fb-p_d.jpg",
        "https://photos.zillowstatic.com/fp/6346d9a5cb36250e4750f4412922fd23-p_d.jpg",
        "https://photos.zillowstatic.com/fp/e40b3bdc0f268652c9d7e7c48d1faf82-p_d.jpg",
        "https://photos.zillowstatic.com/fp/fef61eb3d3fb6fa83d8077b67773a4e7-p_d.jpg",
        "https://photos.zillowstatic.com/fp/974ff9a80ed85f98e9864c362ac95f5b-p_d.jpg",
        "https://photos.zillowstatic.com/fp/b5c28ce2994435958af885e5648f2904-p_d.jpg",
        "https://photos.zillowstatic.com/fp/787879dcd053a8aace821822c16b64cf-p_d.jpg",
        "https://photos.zillowstatic.com/fp/942bdabf98c3ac11fbffa4af3506c73e-p_d.jpg",
        "https://photos.zillowstatic.com/fp/8c86c1654dc2970777a2ec41e9fdb467-p_d.jpg",
        "https://photos.zillowstatic.com/fp/501cfdc69edcff13ca4c11c434f9be27-p_d.jpg",
        "https://photos.zillowstatic.com/fp/7265ae5ebe1daf9932d22acc78e79d0b-p_d.jpg",
        "https://photos.zillowstatic.com/fp/8bb14f240213de10f8b3262bb6be693c-p_d.jpg",
        "https://photos.zillowstatic.com/fp/1ffd6e06050908a0f18bc6e840f292f6-p_d.jpg",
        "https://photos.zillowstatic.com/fp/4e10148e812aa58e357b5db1094037ca-p_d.jpg",
        "https://photos.zillowstatic.com/fp/6e73cb7ea9eddd95b4f05ebc217ec045-p_d.jpg"
      ],
      "homeStatus": "FOR_SALE",
      "price": 3795,
      "rating": 1.8,
      "type": "Guest House",
      "address": {
        "streetAddress": "15740 Morrison St",
        "city": "Encino",
        "state": "CA",
        "zipcode": "91436",
        "neighborhood": null,
        "community": null,
        "subdivision": null
      },
      "yearBuilt": 2022,
      "bedrooms": 5,
      "bathrooms": 6,
      "livingArea": 4279,
      "url": "https://www.zillow.com/homedetails/15740-Morrison-St-Encino-CA-91436/19981046_zpid/",
      "_id": "vlbuv37kdc",
      "__index": 44
    },
    {
      "photos": [
        "https://photos.zillowstatic.com/fp/030d083414e773bdbe2b931026a92030-p_d.jpg",
        "https://photos.zillowstatic.com/fp/49fa9060eb9ce18a4e702ff3f44e4d6a-p_d.jpg",
        "https://photos.zillowstatic.com/fp/47bd8af7d64aface82feae07964fa132-p_d.jpg"
      ],
      "homeStatus": "FOR_SALE",
      "price": 8970,
      "rating": 9.2,
      "type": "Apartment",
      "address": {
        "streetAddress": "1432 Sunrise Ln",
        "city": "Los Angeles",
        "state": "CA",
        "zipcode": "90023",
        "neighborhood": null,
        "community": null,
        "subdivision": "Cabrilla at Ponte Vista"
      },
      "yearBuilt": 2022,
      "bedrooms": 3,
      "bathrooms": 4,
      "livingArea": 1754,
      "url": "https://www.zillow.com/homedetails/1432-Sunrise-Ln-Los-Angeles-CA-90023/2060837730_zpid/",
      "_id": "k0n7vbh1w3j",
      "__index": 45
    },
    {
      "photos": [
        "https://photos.zillowstatic.com/fp/67cf38734079569e28550d19b7e39d7c-p_d.jpg",
        "https://photos.zillowstatic.com/fp/00e73b7bc64ef6f5c26ed09263577d2d-p_d.jpg",
        "https://photos.zillowstatic.com/fp/9f3b666550d6a326c458143155e79d10-p_d.jpg",
        "https://photos.zillowstatic.com/fp/4e5aed73e1836aa89b2030ec24d716ad-p_d.jpg",
        "https://photos.zillowstatic.com/fp/1c0e8e94d30a9cb1192b24c9dd809f28-p_d.jpg",
        "https://photos.zillowstatic.com/fp/be5583e5d25cf716895a62661ec0181c-p_d.jpg",
        "https://photos.zillowstatic.com/fp/3ce9940dd3ec4a1c227c73086d64f79f-p_d.jpg",
        "https://photos.zillowstatic.com/fp/7918bcdd18371ebdfb9585358e67f5dd-p_d.jpg",
        "https://photos.zillowstatic.com/fp/0826f0cdf58f1deb343eca89d0b74634-p_d.jpg",
        "https://photos.zillowstatic.com/fp/b131908381210334cfd5b4178ed659f7-p_d.jpg",
        "https://photos.zillowstatic.com/fp/2fbf4369c2d3118fa127e94f508c94ea-p_d.jpg",
        "https://photos.zillowstatic.com/fp/18b98129a60728e0f0eb2d6266c663e6-p_d.jpg",
        "https://photos.zillowstatic.com/fp/c034db636d5c41bc161d122d6608fa4f-p_d.jpg",
        "https://photos.zillowstatic.com/fp/4467ad8e08dc0184dc6a55b6d478d07a-p_d.jpg",
        "https://photos.zillowstatic.com/fp/33037e46b28ca8ea4049431a8a2f7b41-p_d.jpg",
        "https://photos.zillowstatic.com/fp/817e20b38c33d02f130ab1289e9dc474-p_d.jpg",
        "https://photos.zillowstatic.com/fp/245f8f80f631ce74ebab377840d34063-p_d.jpg",
        "https://photos.zillowstatic.com/fp/4316539bfe5f20349721779e8f18be01-p_d.jpg",
        "https://photos.zillowstatic.com/fp/e0c7e4aec793c8a068be55c45d36c35d-p_d.jpg",
        "https://photos.zillowstatic.com/fp/48e27b157dc2c63938f89d27c3150033-p_d.jpg",
        "https://photos.zillowstatic.com/fp/b6d0e0b9707a5bfd6a7d8abaa49daad9-p_d.jpg",
        "https://photos.zillowstatic.com/fp/6a94044a489fd756e382ff316905f045-p_d.jpg",
        "https://photos.zillowstatic.com/fp/c07da7344721bc4878443f9e39f0af01-p_d.jpg",
        "https://photos.zillowstatic.com/fp/3eed9f43e6ba7b8c4d12c99d9ada0ae9-p_d.jpg",
        "https://photos.zillowstatic.com/fp/1d11df668b7d81a12c060cea7f64d87d-p_d.jpg",
        "https://photos.zillowstatic.com/fp/9cc0232113b4e90fcd6bcffbeb1f3560-p_d.jpg",
        "https://photos.zillowstatic.com/fp/ade1686a7768be16c7e2ac413b7e2433-p_d.jpg",
        "https://photos.zillowstatic.com/fp/3984100706415561fbc6435e048b821c-p_d.jpg",
        "https://photos.zillowstatic.com/fp/35095a39b9cd864905a8cfc29238afa0-p_d.jpg",
        "https://photos.zillowstatic.com/fp/2fc04d8bc390c439c0a8cce743ec5e29-p_d.jpg",
        "https://photos.zillowstatic.com/fp/906bf372760a10de996565b916e39a48-p_d.jpg",
        "https://photos.zillowstatic.com/fp/8da0e2e0844feb896f30f1595ed20411-p_d.jpg",
        "https://photos.zillowstatic.com/fp/dc69a7ffae6ee3919f8431d4960693ee-p_d.jpg",
        "https://photos.zillowstatic.com/fp/034f0e2c732bc71423c34f2e48761702-p_d.jpg",
        "https://photos.zillowstatic.com/fp/8cd7aa421eac5441267387de76187acd-p_d.jpg",
        "https://photos.zillowstatic.com/fp/3e19795053df1e9798c175d50a55d7a7-p_d.jpg",
        "https://photos.zillowstatic.com/fp/70412ac67459a9e9170046ed95060472-p_d.jpg",
        "https://photos.zillowstatic.com/fp/2c2685f134a4eb7b3975545457ea448c-p_d.jpg",
        "https://photos.zillowstatic.com/fp/7da813bf0858f3800d7ecab09546cb51-p_d.jpg",
        "https://photos.zillowstatic.com/fp/9a763a18455ae5083d94f922bae44c81-p_d.jpg"
      ],
      "homeStatus": "FOR_SALE",
      "price": 6250,
      "rating": 7.3,
      "type": "House",
      "address": {
        "streetAddress": "15715 Woodvale Rd",
        "city": "Encino",
        "state": "CA",
        "zipcode": "91436",
        "neighborhood": null,
        "community": null,
        "subdivision": null
      },
      "yearBuilt": 2018,
      "bedrooms": 5,
      "bathrooms": 8,
      "livingArea": 6700,
      "url": "https://www.zillow.com/homedetails/15715-Woodvale-Rd-Encino-CA-91436/19991141_zpid/",
      "_id": "h4i16atkvib",
      "__index": 46
    },
    {
      "photos": [
        "https://photos.zillowstatic.com/fp/1d71552186081e98dd636c84d549b055-p_d.jpg",
        "https://photos.zillowstatic.com/fp/3abf9db2391e7e79ff6ea3707cb55c37-p_d.jpg",
        "https://photos.zillowstatic.com/fp/3b9239414630ae6fd34d733e5a18008f-p_d.jpg",
        "https://photos.zillowstatic.com/fp/80a0844a7d2aed904a40e3deba9380f8-p_d.jpg",
        "https://photos.zillowstatic.com/fp/ec5afb9e0d5ee212f9709db49d11e856-p_d.jpg",
        "https://photos.zillowstatic.com/fp/51783160b6e7038614fb4078aa67f63e-p_d.jpg",
        "https://photos.zillowstatic.com/fp/269a3feed77bbe5028dfdf0cd3ef7504-p_d.jpg",
        "https://photos.zillowstatic.com/fp/6748e1dd54fe3d43017c00c023fd0c8b-p_d.jpg",
        "https://photos.zillowstatic.com/fp/db06c644b36b640c94e4ef4924e8e493-p_d.jpg",
        "https://photos.zillowstatic.com/fp/40144d3ccde57561259b7fd63af09193-p_d.jpg",
        "https://photos.zillowstatic.com/fp/78356d4dbb622a428fec92f4007b1179-p_d.jpg",
        "https://photos.zillowstatic.com/fp/aa80252a619710b8f6f521a8998d5a13-p_d.jpg",
        "https://photos.zillowstatic.com/fp/04ca5966cd4c6aee5fd648d7ed94895a-p_d.jpg",
        "https://photos.zillowstatic.com/fp/a5513c46305c0bbd2fd6f84127ca9ba3-p_d.jpg",
        "https://photos.zillowstatic.com/fp/434f1da30785e46073946fdc7d31b884-p_d.jpg",
        "https://photos.zillowstatic.com/fp/f95f0c40b844d4795cef77820d23ef48-p_d.jpg",
        "https://photos.zillowstatic.com/fp/c119133dda0b15761df886804ef458e0-p_d.jpg",
        "https://photos.zillowstatic.com/fp/eaf63766f90f7e184eb341193c322e1d-p_d.jpg",
        "https://photos.zillowstatic.com/fp/fb2ef9b4d2aa31bb703378d052478bee-p_d.jpg",
        "https://photos.zillowstatic.com/fp/e81d08705e077bbff75eec596ec90aa0-p_d.jpg",
        "https://photos.zillowstatic.com/fp/c19d456a6e42d6bb863e17f9cb990b6a-p_d.jpg",
        "https://photos.zillowstatic.com/fp/47bd8af7d64aface82feae07964fa132-p_d.jpg"
      ],
      "homeStatus": "FOR_SALE",
      "price": 9490,
      "rating": 5.7,
      "type": "Condo",
      "address": {
        "streetAddress": "1445 W Longview Ln",
        "city": "Los Angeles",
        "state": "CA",
        "zipcode": "90068",
        "neighborhood": null,
        "community": null,
        "subdivision": "Cabrilla at Ponte Vista"
      },
      "yearBuilt": 2022,
      "bedrooms": 3,
      "bathrooms": 4,
      "livingArea": 1754,
      "url": "https://www.zillow.com/homedetails/1445-W-Longview-Ln-Los-Angeles-CA-90068/2060837732_zpid/",
      "_id": "fgr7y35dfqu",
      "__index": 47
    },
    {
      "photos": [
        "https://photos.zillowstatic.com/fp/c95fad107dd005aa98e1e968265f7911-p_d.jpg",
        "https://photos.zillowstatic.com/fp/196e32270dcfb39cace7b877b24b2b98-p_d.jpg",
        "https://photos.zillowstatic.com/fp/fbb711b5d9f5b1d90a3a1ef2348711f9-p_d.jpg",
        "https://photos.zillowstatic.com/fp/1bfed7f961532e872b166980f09d662b-p_d.jpg",
        "https://photos.zillowstatic.com/fp/9aebd420846c027a8db849f74fca97b8-p_d.jpg",
        "https://photos.zillowstatic.com/fp/f6de859afa444bf6a7f0bd013a57b7ec-p_d.jpg",
        "https://photos.zillowstatic.com/fp/a3d2a98d5ccbae196ae074ed2f9ad27e-p_d.jpg",
        "https://photos.zillowstatic.com/fp/a8d04eef4e208f0df0874ed427053177-p_d.jpg",
        "https://photos.zillowstatic.com/fp/cac75dbb33c7474665695b62888ba213-p_d.jpg",
        "https://photos.zillowstatic.com/fp/00c355561ad9e27374f238027fcb4474-p_d.jpg",
        "https://photos.zillowstatic.com/fp/c418b5cc78f62582deb895ca2fadab84-p_d.jpg",
        "https://photos.zillowstatic.com/fp/2fd3c50739fc8b557c77193bd7ca751c-p_d.jpg",
        "https://photos.zillowstatic.com/fp/30a69579e77048444359bff4bb9b343e-p_d.jpg",
        "https://photos.zillowstatic.com/fp/32971985337464c10f7ee83f3a9fb47e-p_d.jpg",
        "https://photos.zillowstatic.com/fp/512c0a97e1dbcf294909fab5033d839c-p_d.jpg"
      ],
      "homeStatus": "FOR_SALE",
      "price": 3000,
      "rating": 9.9,
      "type": "Villa",
      "address": {
        "streetAddress": "4307 W Rose Hill Dr",
        "city": "Los Angeles",
        "state": "CA",
        "zipcode": "90032",
        "neighborhood": null,
        "community": null,
        "subdivision": null
      },
      "yearBuilt": 1907,
      "bedrooms": 2,
      "bathrooms": 2,
      "livingArea": 1250,
      "url": "https://www.zillow.com/homedetails/4307-W-Rose-Hill-Dr-Los-Angeles-CA-90032/95603077_zpid/",
      "_id": "qlpbmu5hypk",
      "__index": 48
    },
    {
      "photos": [
        "https://photos.zillowstatic.com/fp/c71b38246826b63a296f61f9aa0ae19b-p_d.jpg",
        "https://photos.zillowstatic.com/fp/7f225c7405d6174e695ada170fdd317c-p_d.jpg",
        "https://photos.zillowstatic.com/fp/f1fe1031889518108b1a0923b1094320-p_d.jpg",
        "https://photos.zillowstatic.com/fp/75fc4fc72658b702f924450024f327b8-p_d.jpg",
        "https://photos.zillowstatic.com/fp/ad78255903c75e574b5afaeb62cead35-p_d.jpg",
        "https://photos.zillowstatic.com/fp/a28e48e2a1d45912ed72174e9df6dcae-p_d.jpg",
        "https://photos.zillowstatic.com/fp/1d3b60c6411571934f360da17fed27c6-p_d.jpg",
        "https://photos.zillowstatic.com/fp/d00e29c1ec48f178cf936491961cda70-p_d.jpg",
        "https://photos.zillowstatic.com/fp/c31c4b14fcef33cada99dafef320ef84-p_d.jpg",
        "https://photos.zillowstatic.com/fp/a6a634255c0c41e6d37cd1ea94ce101c-p_d.jpg",
        "https://photos.zillowstatic.com/fp/905db7b0f12061cff86cd80bd66e4ebd-p_d.jpg",
        "https://photos.zillowstatic.com/fp/888afc48c6fff93f86e6d2595c9fda0d-p_d.jpg",
        "https://photos.zillowstatic.com/fp/f75e83ddbb8385b545b4d55259a937fc-p_d.jpg",
        "https://photos.zillowstatic.com/fp/675185b5d441390d185475b998500678-p_d.jpg",
        "https://photos.zillowstatic.com/fp/059aad8d635c936fd43ae094f5b7bc3d-p_d.jpg",
        "https://photos.zillowstatic.com/fp/56e417fbd2bc02fbd346e810f5900d7e-p_d.jpg",
        "https://photos.zillowstatic.com/fp/2c72906524bf6649897200a35352d78f-p_d.jpg",
        "https://photos.zillowstatic.com/fp/e2f004c4c3f7220fa4c61e6834f0b774-p_d.jpg",
        "https://photos.zillowstatic.com/fp/41a37f35d5365c8e40e960b79de40d45-p_d.jpg",
        "https://photos.zillowstatic.com/fp/48c31ae0f9c7a32048b788e02d50bf6f-p_d.jpg",
        "https://photos.zillowstatic.com/fp/5f82a33455bc160a719439f003d9b3c6-p_d.jpg"
      ],
      "homeStatus": "FOR_SALE",
      "price": 1826,
      "rating": 3.6,
      "type": "House",
      "address": {
        "streetAddress": "4951 Cedros Ave",
        "city": "Sherman Oaks",
        "state": "CA",
        "zipcode": "91403",
        "neighborhood": null,
        "community": null,
        "subdivision": null
      },
      "yearBuilt": 1936,
      "bedrooms": 4,
      "bathrooms": 5,
      "livingArea": 2411,
      "url": "https://www.zillow.com/homedetails/4951-Cedros-Ave-Sherman-Oaks-CA-91403/19982399_zpid/",
      "_id": "9illawpuymg",
      "__index": 49
    },
    {
      "photos": [
        "https://photos.zillowstatic.com/fp/ab7413641bbcfad5e79a9a2b34707c96-p_d.jpg",
        "https://photos.zillowstatic.com/fp/9ae553d8884ab722407f39b7f8feec70-p_d.jpg",
        "https://photos.zillowstatic.com/fp/4e8f542f7e950beee680f056dfd5d23b-p_d.jpg",
        "https://photos.zillowstatic.com/fp/aeec1d1cbd04ecb53b352f3ea00fda1f-p_d.jpg",
        "https://photos.zillowstatic.com/fp/844dbd6923e84e11b5ad8e92c55a7f79-p_d.jpg",
        "https://photos.zillowstatic.com/fp/e869eb412bad97abbf3eaca34e0d3c70-p_d.jpg",
        "https://photos.zillowstatic.com/fp/785c2a0e2d742e7bfbc2bf98a4a82be5-p_d.jpg",
        "https://photos.zillowstatic.com/fp/902ad1422b1daff30585925412e874c5-p_d.jpg",
        "https://photos.zillowstatic.com/fp/0346587e2a184af5a5ada88eb020555a-p_d.jpg",
        "https://photos.zillowstatic.com/fp/3f84d1a27f8b8645846d5089c3a3ac3f-p_d.jpg",
        "https://photos.zillowstatic.com/fp/159d743d7e0a0e7f65cbd62f20265900-p_d.jpg",
        "https://photos.zillowstatic.com/fp/caadaf449ebaaa934e5fd6e6f9e590aa-p_d.jpg",
        "https://photos.zillowstatic.com/fp/c0952a4b62b377c8a3520958874ad2bf-p_d.jpg",
        "https://photos.zillowstatic.com/fp/e0b6b24400123e4a4503881f17f6b2d6-p_d.jpg",
        "https://photos.zillowstatic.com/fp/8f5f83ca9715c89658f280e4fc2fb06b-p_d.jpg",
        "https://photos.zillowstatic.com/fp/ecb4062b2cc458eb59c1e49c7c2f0b16-p_d.jpg",
        "https://photos.zillowstatic.com/fp/f48ffae839907a0135263a214715f2d0-p_d.jpg",
        "https://photos.zillowstatic.com/fp/b03715315669d4b5757b0bfb09e66e30-p_d.jpg",
        "https://photos.zillowstatic.com/fp/9dcf84130dd854cbcf3331f0c2d4690f-p_d.jpg",
        "https://photos.zillowstatic.com/fp/1a16b42ace3e1bc739a7674957d5bb72-p_d.jpg",
        "https://photos.zillowstatic.com/fp/ce7ec1be7e9feb4f70042afa8fcfb3b9-p_d.jpg",
        "https://photos.zillowstatic.com/fp/568f2b799589b912a840d0e10749ee28-p_d.jpg",
        "https://photos.zillowstatic.com/fp/6d25061ae31d9069bcca03c8a6de1fc8-p_d.jpg",
        "https://photos.zillowstatic.com/fp/e2dadd78d3bfed1232c6cfa24595e0ba-p_d.jpg",
        "https://photos.zillowstatic.com/fp/bd1d97bbe0251ca9894c9579667dd7c4-p_d.jpg",
        "https://photos.zillowstatic.com/fp/eddd050baa7bfcf7ea3fde6e66bede65-p_d.jpg",
        "https://photos.zillowstatic.com/fp/cea4a80fece28ebd1923483c9b8eaedb-p_d.jpg",
        "https://photos.zillowstatic.com/fp/04f94040a1ec13d723e485e9ab1d8b8c-p_d.jpg",
        "https://photos.zillowstatic.com/fp/a79ddd27bf8cca0eef0a05c438f125f3-p_d.jpg",
        "https://photos.zillowstatic.com/fp/4293ec6378c9daaac7e25ddc83c90b58-p_d.jpg",
        "https://photos.zillowstatic.com/fp/3ea254ff19768b264c835562f3f8a12a-p_d.jpg",
        "https://photos.zillowstatic.com/fp/1cb98e1a574bbee8a1db0439cc904536-p_d.jpg",
        "https://photos.zillowstatic.com/fp/b2b47b89c6015770dba47a8f862b3827-p_d.jpg",
        "https://photos.zillowstatic.com/fp/efdd714a5da60b92869469ec05e1c867-p_d.jpg",
        "https://photos.zillowstatic.com/fp/1dc4b952764a0b9f436becf073aee689-p_d.jpg",
        "https://photos.zillowstatic.com/fp/75c503ee404cfe8f60d25aa6123448f1-p_d.jpg",
        "https://photos.zillowstatic.com/fp/f82971861a1d8cd9b89e9feb2684c8db-p_d.jpg",
        "https://photos.zillowstatic.com/fp/3dbebd573e5955ce7bd6fb5c20eb556d-p_d.jpg",
        "https://photos.zillowstatic.com/fp/40fdd2a45b5efc8ef4e7bb2eb18211dd-p_d.jpg",
        "https://photos.zillowstatic.com/fp/2d1dd1346411466bb43a98202c542f2e-p_d.jpg",
        "https://photos.zillowstatic.com/fp/3979d2878b02eca386ace7ce7506c7ab-p_d.jpg",
        "https://photos.zillowstatic.com/fp/1d03fd512d3af39f2f7fdf011e9a92c1-p_d.jpg",
        "https://photos.zillowstatic.com/fp/5caefa4a9f48924b96746112c4c5f2c3-p_d.jpg",
        "https://photos.zillowstatic.com/fp/96f82fe26ab8cbf7b1b48d2cc2eb0909-p_d.jpg",
        "https://photos.zillowstatic.com/fp/cae518ddbce51049ca931dcdb9ab1edf-p_d.jpg",
        "https://photos.zillowstatic.com/fp/0d127cb5d621f9debc3bd49d7df0863e-p_d.jpg",
        "https://photos.zillowstatic.com/fp/2beee82d0fa7c13c0bc22d7f15aab01c-p_d.jpg",
        "https://photos.zillowstatic.com/fp/b0e225bb177df7d72501e90a99304277-p_d.jpg",
        "https://photos.zillowstatic.com/fp/8688bcb006f4cec66357891034b8bfb3-p_d.jpg",
        "https://photos.zillowstatic.com/fp/b593d485a961da7a56b44c5b003114c9-p_d.jpg",
        "https://photos.zillowstatic.com/fp/31e02dfcbc9a651272ed4eea37541055-p_d.jpg",
        "https://photos.zillowstatic.com/fp/e59ced1a3802ccafdbd0f6d5658e32dd-p_d.jpg",
        "https://photos.zillowstatic.com/fp/c75b72c7b224993eff22c9c3ca4a0611-p_d.jpg",
        "https://photos.zillowstatic.com/fp/3ab83b19a93566e9240e8a6e1314cd87-p_d.jpg",
        "https://photos.zillowstatic.com/fp/d85338d8379f2a7daf583aac28dcd17d-p_d.jpg",
        "https://photos.zillowstatic.com/fp/2fc9419187deefc5eba0085d632d530c-p_d.jpg",
        "https://photos.zillowstatic.com/fp/225896c39c398f7cef312f15d2a5626e-p_d.jpg",
        "https://photos.zillowstatic.com/fp/e457aaea1656126481423ef7ef7cd6e9-p_d.jpg",
        "https://photos.zillowstatic.com/fp/8beb56356282a964a05acb78432c5784-p_d.jpg",
        "https://photos.zillowstatic.com/fp/ae03ee8015ca081ffaf1768c7556cdd5-p_d.jpg",
        "https://photos.zillowstatic.com/fp/50d36d03d922aa7e927d6d3c6c928f84-p_d.jpg",
        "https://photos.zillowstatic.com/fp/4cea2a22cbb72eacf8ad306bf6477fc1-p_d.jpg",
        "https://photos.zillowstatic.com/fp/878fda45e58770027dba6f71fb155653-p_d.jpg",
        "https://photos.zillowstatic.com/fp/30ea79c8ba0452a89e84cfd2671139f4-p_d.jpg",
        "https://photos.zillowstatic.com/fp/d102938654602d49985ac25f7052a4c3-p_d.jpg",
        "https://photos.zillowstatic.com/fp/f71f8047be8d094b58e178eecf0e7826-p_d.jpg",
        "https://photos.zillowstatic.com/fp/cecc42b8574ee22c3412ee3e81954252-p_d.jpg",
        "https://photos.zillowstatic.com/fp/c6a7eb674d56ba910fcd8cf4dee66de1-p_d.jpg",
        "https://photos.zillowstatic.com/fp/35a4c9fdb0506a5aa2cd2ff842f64ea0-p_d.jpg",
        "https://photos.zillowstatic.com/fp/f712a21077c6c2bb778b03ac416df5b7-p_d.jpg",
        "https://photos.zillowstatic.com/fp/ee75de5bf193499261af27d7f33f9952-p_d.jpg",
        "https://photos.zillowstatic.com/fp/a53370b393c29fdfcb416a0d636923df-p_d.jpg",
        "https://photos.zillowstatic.com/fp/71d90dec036c376d2cb831592d43741a-p_d.jpg",
        "https://photos.zillowstatic.com/fp/8fe83faa5f4d2bf6ce63d0646369eddb-p_d.jpg",
        "https://photos.zillowstatic.com/fp/d842f6a49a6bbf5a58742a266fb6d920-p_d.jpg"
      ],
      "homeStatus": "FOR_SALE",
      "price": 7399,
      "rating": 7.9,
      "type": "Condo",
      "address": {
        "streetAddress": "365 S June St",
        "city": "Los Angeles",
        "state": "CA",
        "zipcode": "90020",
        "neighborhood": null,
        "community": null,
        "subdivision": null
      },
      "yearBuilt": 1928,
      "bedrooms": 8,
      "bathrooms": 6,
      "livingArea": 6915,
      "url": "https://www.zillow.com/homedetails/365-S-June-St-Los-Angeles-CA-90020/20775357_zpid/",
      "_id": "ib0mlo2krp",
      "__index": 50
    }
  ]